import React, { useEffect, useMemo, useState } from 'react'
import { supabase } from '../../supabaseClient'
import Swal from 'sweetalert2'
import Header from '../../components/Header'
import LoyaltyAnalytics from './LoyaltyAnalytics'
import { useNavigate } from 'react-router-dom'
import { authHeaders } from '../../utils/authFetch'

// ─── Design tokens ────────────────────────────────────────────────────
const C = {
    espresso: 'transparent',
    dark: '#F9FAFB',
    card: '#FFFFFF',
    border: '#E5E7EB',
    muted: '#9CA3AF',
    text: '#111827',
    textSoft: '#6B7280',
    amber: '#D97706',
    gold: '#B45309',
    teal: '#0D9488',
    coral: '#DC2626',
    blue: '#2563EB',
    green: '#16A34A',
    purple: '#7C3AED',
    indigo: '#4F46E5',
    nude: '#A0826D',
    midgrey: '#6B7280',
}

export default function LoyaltyRewards({ onGoToProfile }) {
    const [activeTab, setActiveTab] = useState('overview')

    // Pagination
    const [tierPage, setTierPage] = useState(1)
    const [achievementPage, setAchievementPage] = useState(1)
    const [rewardPage, setRewardPage] = useState(1)
    const [campaignPage, setCampaignPage] = useState(1)
    const [rewardLinkedItemPickerPage, setRewardLinkedItemPickerPage] = useState(1)
    const [campaignRewardPickerPage, setCampaignRewardPickerPage] = useState(1)
    const PAGE_SIZE = 10
    const TIER_PAGE_SIZE = 5

    const [customerTiers, setCustomerTiers] = useState([])
    const [tierImageFile, setTierImageFile] = useState(null)
    const [tierImageInputMode, setTierImageInputMode] = useState('upload')
    const [uploadingTierImage, setUploadingTierImage] = useState(false)

    const [achievements, setAchievements] = useState([])
    const [achievementImageFile, setAchievementImageFile] = useState(null)
    const [achievementImageInputMode, setAchievementImageInputMode] = useState('upload')
    const [uploadingAchievementImage, setUploadingAchievementImage] = useState(false)

    const [menuCategories, setMenuCategories] = useState([])
    const [menuItemsList, setMenuItemsList] = useState([])
    const [rewardLinkedItems, setRewardLinkedItems] = useState([])

    const [rewardsCatalog, setRewardsCatalog] = useState([])
    const [rewardsRedeemedTodayCount, setRewardsRedeemedTodayCount] = useState(0)

    const [activeCampaigns, setActiveCampaigns] = useState([])
    const [activeMembersCount, setActiveMembersCount] = useState(0)

    const [branches, setBranches] = useState([])
    const [selectedBranchIds, setSelectedBranchIds] = useState(new Set())
    const [initialSelectedBranchIds, setInitialSelectedBranchIds] = useState(new Set())

    const [achievementView, setAchievementView] = useState('active')
    const [rewardView, setRewardView] = useState('active')
    const [campaignView, setCampaignView] = useState('active')

    // Modals
    const [showAddTierModal, setShowAddTierModal] = useState(false)
    const [showEditTierModal, setShowEditTierModal] = useState(false)
    const [showAddAchievementModal, setShowAddAchievementModal] = useState(false)
    const [showEditAchievementModal, setShowEditAchievementModal] = useState(false)
    const [showAddRewardModal, setShowAddRewardModal] = useState(false)
    const [showEditRewardModal, setShowEditRewardModal] = useState(false)
    const [showAddCampaignModal, setShowAddCampaignModal] = useState(false)
    const [showEditCampaignModal, setShowEditCampaignModal] = useState(false)
    const [showCampaignDetailsModal, setShowCampaignDetailsModal] = useState(false)
    const [viewingCampaign, setViewingCampaign] = useState(null)

    // Archived viewer modal
    const [showArchivedViewerModal, setShowArchivedViewerModal] = useState(false)
    const [archivedViewerTab, setArchivedViewerTab] = useState('tiers')

    const [editingTier, setEditingTier] = useState(null)
    const [editingAchievement, setEditingAchievement] = useState(null)
    const [editingReward, setEditingReward] = useState(null)
    const [editingCampaign, setEditingCampaign] = useState(null)

    const [archivedTiers, setArchivedTiers] = useState([])
    const [archivedRewards, setArchivedRewards] = useState([])
    const [archivedCampaigns, setArchivedCampaigns] = useState([])
    const [archivedAchievements, setArchivedAchievements] = useState([])
    const [rewardAvailabilityFilter, setRewardAvailabilityFilter] = useState('all')
    const [archivedSearch, setArchivedSearch] = useState('')
    const [archivedPage, setArchivedPage] = useState(1)
    const [archivedCampaignTypeFilter, setArchivedCampaignTypeFilter] = useState('All')
    const [archivedAchievementTypeFilter, setArchivedAchievementTypeFilter] = useState('All')
    const [archivedRewardTypeFilter, setArchivedRewardTypeFilter] = useState('All')

    const [tierSearch, setTierSearch] = useState('')
    const [achievementSearch, setAchievementSearch] = useState('')
    const [rewardSearch, setRewardSearch] = useState('')
    const [campaignSearch, setCampaignSearch] = useState('')
    const [rewardAchievementSearch, setRewardAchievementSearch] = useState('')
    const [campaignRewardSearch, setCampaignRewardSearch] = useState('')
    const [linkedItemSearch, setLinkedItemSearch] = useState('')

    const navigate = useNavigate();
    const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080'

    const areSetsEqual = (setA = new Set(), setB = new Set()) => {
        if (setA.size !== setB.size) return false
        for (const value of setA) {
            if (!setB.has(value)) return false
        }
        return true
    }

    const MAX_LENGTHS = {
        tierName: 50,
        benefit: 250,
        achievementTitle: 30,
        achievementDescription: 300,
        achievementCondition: 300,
        rewardName: 100,
        rewardDescription: 300,
        rewardGuidelines: 500,
        campaignName: 120,
        campaignReward: 150,
        campaignDescription: 300,
        campaignGuidelines: 500,

        minPoints: 7,
        maxPoints: 7,
        rewardPoints: 6,
        targetValue: 6,
        pointsRequired: 6,
        rewardValue: 6,
        minimumSpend: 6,
        multiplier: 4,
        bonusPoints: 6,
        promoMinOrderCount: 4,
        discountValue: 6,
    }

    const REWARD_TYPE_FILTER_OPTIONS = [
        { value: 'All', label: 'All Types' },
        { value: 'logic:point', label: 'Point-Based' },
        { value: 'logic:order', label: 'Order-Based' },
        { value: 'logic:achievement', label: 'Achievement-Based' },
        { value: 'logic:promo', label: 'Promo-Based' },
        { value: 'value:fixed_amount', label: 'Fixed Amount' },
        { value: 'value:percentage', label: 'Percentage' },
        { value: 'value:bonus_points', label: 'Bonus Points' },
        { value: 'duration:Permanent', label: 'Permanent' },
        { value: 'duration:Limited', label: 'Limited-Time' },
    ]

    const ACHIEVEMENT_TYPE_FILTER_OPTIONS = [
        { value: 'All', label: 'All Rule Types' },
        { value: 'rule:completed_orders', label: 'Completed Orders' },
        { value: 'rule:category_orders', label: 'Category Orders' },
        { value: 'rule:branch_visits', label: 'Branch Visits' },
        { value: 'rule:total_spend', label: 'Total Spend' },
        { value: 'rule:reward_redemptions', label: 'Reward Redemptions' },
        { value: 'timeframe:none', label: 'Permanent' },
        { value: 'timeframe:limited', label: 'Limited (Daily/Weekly/Monthly)' },
    ]

    const [recentRedemptions] = useState([
        {
            id: 1,
            customerName: 'Christianne Navarro',
            reward: 'Free Cappuccino',
            points: 500,
            redeemedAt: '2026-02-11T08:30:00',
            status: 'completed'
        },
        {
            id: 2,
            customerName: 'Christianne Marie Navarro',
            reward: '20% Off Next Order',
            points: 300,
            redeemedAt: '2026-02-11T07:15:00',
            status: 'completed'
        },
        {
            id: 3,
            customerName: 'Juan Dela Cruz',
            reward: 'Free Croissant',
            points: 200,
            redeemedAt: '2026-02-10T16:45:00',
            status: 'completed'
        },
        {
            id: 4,
            customerName: 'Maria Santos',
            reward: 'Buy 1 Get 1 Coffee',
            points: 800,
            redeemedAt: '2026-02-10T14:20:00',
            status: 'pending'
        }
    ])

    const [tierFormData, setTierFormData] = useState({
        name: '',
        minPoints: '',
        maxPoints: '',
        benefits: [''],
        image_url: ''
    })

    const [achievementFormData, setAchievementFormData] = useState({
        title: '',
        description: '',
        rewardPoints: '',
        status: 'active',
        image_url: '',
        rule_type: 'completed_orders',
        target_value: '',
        category_name: '',
        branch_id: '',
        timeframe_type: 'none',
        condition_label: ''
    })

    const [rewardFormData, setRewardFormData] = useState({
        name: '',
        type: '',
        reward_logic_type: 'point',

        description: '',
        points_required: '',
        reward_value_type: '',
        reward_value: '',
        max_discount_amount: '',

        stock_quantity: '',
        start_at: '',
        end_at: '',
        is_featured: false,
        mechanics: '',
        minimum_spend: '',
        min_order_count: '',
        min_total_spent: '',
        bonus_points: '',
        promo_min_order_count: '',
        application_scope: 'all',
        applies_to_category: '',

        achievement_id: '',
        linked_item_id: '',
        linked_variant_id: ''
    })

    const [campaignFormData, setCampaignFormData] = useState({
        name: '',
        type: 'Promotion',
        startDate: '',
        endDate: '',
        startTime: '00:00',
        endTime: '23:59',
        status: 'scheduled',
        description: '',
        mechanics: '',

        // Promotion-only
        promotionMechanicType: 'multiplier', // 'multiplier' | 'discount'
        multiplier: '',
        discountValueType: 'fixed_amount',   // 'fixed_amount' | 'percentage'
        discountValue: '',

        linkedRewardId: '',
    })

    const [initialTierFormData, setInitialTierFormData] = useState(null)
    const [initialAchievementFormData, setInitialAchievementFormData] = useState(null)
    const [initialRewardFormData, setInitialRewardFormData] = useState(null)
    const [initialCampaignFormData, setInitialCampaignFormData] = useState(null)
    const [initialRewardLinkedItems, setInitialRewardLinkedItems] = useState([])

    // ─── Local-only duplicate check (tiers use client state, no RLS issue) ────
    const checkDuplicateTierName = (name, excludeId = null) => {
        return customerTiers.some(
            (t) => t.name.toLowerCase() === name.trim().toLowerCase() && t.id !== excludeId
        )
    }

    const formatCampaignType = (dbType) => {
        switch (dbType) {
            case 'promotion': return 'Promotion'
            case 'challenge': return 'Challenge'
            default: return dbType
        }
    }

    const extractTimeFromISO = (isoString) => {
        if (!isoString) return '00:00'
        const d = new Date(isoString)
        const hh = String(d.getHours()).padStart(2, '0')
        const mm = String(d.getMinutes()).padStart(2, '0')
        return `${hh}:${mm}`
    }

    // ─── Mappers ────────────────────────────────────────────────────────────
    const mapAchievement = (a) => ({
        id: a.achievement_id,
        title: a.title || '',
        description: a.description || '',
        rewardPoints: a.reward_points || 0,
        condition: a.achievement_rules?.[0]?.condition_label || '',
        ruleType: a.achievement_rules?.[0]?.rule_type || 'completed_orders',
        targetValue: a.achievement_rules?.[0]?.target_value || '',
        categoryName: a.achievement_rules?.[0]?.category_name || '',
        branchId: a.achievement_rules?.[0]?.branch_id || '',
        timeframeType: a.achievement_rules?.[0]?.timeframe_type || 'none',
        status: a.status || 'active',
        ruleId: a.achievement_rules?.[0]?.rule_id || null,
        image_url: a.badge_icon || ''
    })

    const mapArchivedAchievement = (a) => ({
        id: a.achievement_id,
        title: a.title || '',
        description: a.description || '',
        rewardPoints: a.reward_points || 0,
        condition: a.achievement_rules?.[0]?.condition_label || '',
        ruleType: a.achievement_rules?.[0]?.rule_type || 'completed_orders',
        timeframeType: a.achievement_rules?.[0]?.timeframe_type || 'none',
        status: a.status || 'active',
        ruleId: a.achievement_rules?.[0]?.rule_id || null
    })

    const mapReward = (r) => ({
        id: r.reward_id,
        name: r.reward_name,
        description: r.description || '',
        mechanics: r.mechanics || '',
        minimumSpend: r.minimum_spend ?? '',
        rewardLogicType: r.reward_logic_type || 'point',
        rewardValue: r.reward_value ?? '',
        maxDiscountAmount: r.max_discount_amount ?? '',
        rewardValueType: r.reward_value_type || '',
        pointsRequired: r.points_required,
        bonusPoints: r.bonus_points ?? '',
        promoMinOrderCount: r.promo_min_order_count ?? '',
        applicationScope: r.application_scope || 'all',
        appliesToCategory: r.applies_to_category || '',
        rewardDurationType: r.availability_status === 'limited' ? 'Limited' : 'Permanent',
        startDate: r.start_at ? r.start_at.split('T')[0] : '',
        endDate: r.end_at ? r.end_at.split('T')[0] : '',
        isFeatured: r.is_featured,
        status: r.is_active ? 'active' : 'inactive'
    })

    const mapCampaign = (c) => {
        const now = new Date()
        return {
            id: c.promotion_id,
            name: c.promotion_name,
            type: formatCampaignType(c.promotion_type),
            startDate: c.start_at.split('T')[0],
            endDate: c.end_at.split('T')[0],
            startTime: extractTimeFromISO(c.start_at),
            endTime: extractTimeFromISO(c.end_at),
            status: c.status,
            isActive: c.status !== 'cancelled' && now >= new Date(c.start_at) && now <= new Date(c.end_at),
            description: c.description || '',
            mechanics: c.mechanics || '',
            minimumSpend: c.minimum_spend ? String(c.minimum_spend) : '',
            minOrderCount: c.min_order_count ? String(c.min_order_count) : '',
            linkedRewardId: c.linked_reward_id || ''
        }
    }

    const mapArchivedCampaign = (c) => ({
        id: c.promotion_id,
        name: c.promotion_name,
        type: formatCampaignType(c.promotion_type),
        startDate: c.start_at ? c.start_at.split('T')[0] : '',
        endDate: c.end_at ? c.end_at.split('T')[0] : '',
        startTime: extractTimeFromISO(c.start_at),
        endTime: extractTimeFromISO(c.end_at),
        status: c.status || 'scheduled',
        linkedRewardId: c.linked_reward_id || '',
        description: c.description || '',
        mechanics: c.mechanics || ''
    })

    // ─── Data loaders ───────────────────────────────────────────────────────
    const loadLoyaltyRewardsData = async () => {
        try {
            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/data`, { headers: authHeaders() })
            if (!res.ok) throw new Error('Failed to load loyalty rewards data')
            const data = await res.json()

            setAchievements((data.achievements || []).map(mapAchievement))
            setRewardsCatalog((data.rewards || []).map(mapReward))
            setActiveCampaigns((data.campaigns || []).map(mapCampaign))
            setActiveMembersCount(data.activeMembersCount || 0)

            setCustomerTiers((data.tiers || []).map((tier, index, arr) => ({
                id: tier.tier_id,
                name: tier.tier_name,
                minPoints: tier.points_required,
                maxPoints: index < arr.length - 1 ? arr[index + 1].points_required - 1 : null,
                members: tier.member_count ?? 0,
                benefits: (tier.loyalty_tier_benefits || []).map((b) => b.benefit_description),
                image_url: tier.tier_icon || ''
            })))

            setRewardsRedeemedTodayCount(data.rewardsRedeemedTodayCount || 0)
            setBranches(data.branches || [])
            setMenuCategories(data.menuCategories || [])
            setMenuItemsList((data.menuItems || []).map((item) => ({
                ...item,
                variants: (item.menu_variants || []).map((mv) => mv.item_variants).filter(Boolean)
            })))

            setArchivedTiers(data.archivedTiers || [])
            setArchivedRewards((data.archivedRewards || []).map(mapReward))
            setArchivedCampaigns((data.archivedCampaigns || []).map(mapArchivedCampaign))
            setArchivedAchievements((data.archivedAchievements || []).map(mapArchivedAchievement))
        } catch (err) {
            console.error('Error fetching loyalty rewards data:', err)
            Swal.fire({
                icon: 'error',
                title: 'Failed to Load Loyalty Rewards Data',
                text: err.message,
                confirmButtonColor: '#8B5A3C'
            })
        }
    }

    const fetchCampaigns = async () => {
        try {
            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/campaigns`, { headers: authHeaders() })
            if (!res.ok) throw new Error('Failed to load campaigns')
            const { campaigns } = await res.json()
            setActiveCampaigns(campaigns.map(mapCampaign))
        } catch (err) {
            console.error('Error fetching campaigns:', err)
            Swal.fire({
                icon: 'error',
                title: 'Failed to Load Campaigns',
                text: err.message,
                confirmButtonColor: '#8B5A3C'
            })
        }
    }

    // ─── Image uploads ──────────────────────────────────────────────────────
    const uploadTierImage = async (file) => {
        if (!file) return null
        const formData = new FormData()
        formData.append('image', file)
        formData.append('label', tierFormData.name)

        const res = await fetch(`${BASE_URL}/api/loyalty-rewards/upload/tier-image`, {
            method: 'POST',
            headers: authHeaders(),
            body: formData
        })
        const data = await res.json()
        if (!res.ok) throw new Error(data.error || 'Failed to upload tier image.')
        return data.url
    }

    const uploadAchievementImage = async (file) => {
        if (!file) return null
        const formData = new FormData()
        formData.append('image', file)
        formData.append('label', achievementFormData.title)

        const res = await fetch(`${BASE_URL}/api/loyalty-rewards/upload/achievement-image`, {
            method: 'POST',
            body: formData
        })
        const data = await res.json()
        if (!res.ok) throw new Error(data.error || 'Failed to upload achievement image.')
        return data.url
    }

    const generateConditionLabel = (formData) => {
        const { rule_type, target_value, category_name, branch_id, timeframe_type } = formData
        const timeframeText = timeframe_type && timeframe_type !== 'none' ? ` within a ${timeframe_type}` : ''
        const branchName = branches.find(b => b.branch_id === branch_id)?.name || ''

        switch (rule_type) {
            case 'completed_orders':
                return `Complete ${target_value} order${target_value != 1 ? 's' : ''}${timeframeText}`
            case 'category_orders':
                return `Order ${target_value} ${category_name || 'item'}${target_value != 1 ? 's' : ''} from ${category_name || 'selected category'}${timeframeText}`
            case 'total_spend':
                return `Spend ₱${Number(target_value).toLocaleString()}${timeframeText}`
            case 'branch_visits':
                return `Visit ${branchName || 'a branch'} ${target_value} time${target_value != 1 ? 's' : ''}${timeframeText}`
            case 'reward_redemptions':
                return `Redeem ${target_value} reward${target_value != 1 ? 's' : ''}${timeframeText}`
            default:
                return ''
        }
    }

    // Normalize
    const normalizeArrayStrings = (arr = []) => arr.map((item) => String(item || '').trim()).filter(Boolean)

    const normalizeTierFormData = (data = {}) => ({
        name: String(data.name || '').trim(),
        minPoints: String(data.minPoints || '').trim(),
        maxPoints: String(data.maxPoints || '').trim(),
        benefits: normalizeArrayStrings(data.benefits || []),
        image_url: String(data.image_url || '').trim()
    })

    const normalizeAchievementFormData = (data = {}) => ({
        title: String(data.title || '').trim(),
        description: String(data.description || '').trim(),
        rewardPoints: String(data.rewardPoints || '').trim(),
        status: String(data.status || 'active').trim(),
        rule_type: String(data.rule_type || 'completed_orders').trim(),
        target_value: String(data.target_value || '').trim(),
        category_name: String(data.category_name || '').trim(),
        branch_id: String(data.branch_id || '').trim(),
        timeframe_type: String(data.timeframe_type || 'none').trim(),
        condition_label: String(data.condition_label || '').trim(),
        image_url: String(data.image_url || '').trim()
    })

    const normalizeRewardFormData = (data = {}) => ({
        name: String(data.name || '').trim(),
        rewardLogicType: String(data.reward_logic_type || 'point').trim(),
        description: String(data.description || '').trim(),
        mechanics: String(data.mechanics || '').trim(),
        pointsRequired: String(data.points_required || '').trim(),
        minOrderCount: String(data.min_order_count || '').trim(),
        minTotalSpent: String(data.min_total_spent || '').trim(),
        bonusPoints: String(data.bonus_points || '').trim(),
        promoMinOrderCount: String(data.promo_min_order_count || '').trim(),
        achievementId: String(data.achievement_id || '').trim(),
        rewardValueType: data.reward_value_type || null,
        rewardValue:
            data.reward_value !== '' && data.reward_value != null
                ? Number(data.reward_value)
                : null,
        maxDiscountAmount:
            data.max_discount_amount !== '' && data.max_discount_amount != null
                ? Number(data.max_discount_amount)
                : null,
        rewardDurationType: String(data.rewardDurationType || 'Permanent').trim(),
        startDate: String(data.startDate || '').trim(),
        endDate: String(data.endDate || '').trim(),
        status: String(data.status || 'active').trim(),
        linkedItemId: String(data.linked_item_id || '').trim(),
        linkedVariantId: String(data.linked_variant_id || '').trim(),
        applicationScope: String(data.application_scope || 'all').trim(),
        appliesToCategory: String(data.applies_to_category || '').trim(),
    })

    const normalizeCampaignFormData = (data = {}) => ({
        name: String(data.name || '').trim(),
        type: String(data.type || 'Promotion').trim(),
        startDate: String(data.startDate || '').trim(),
        endDate: String(data.endDate || '').trim(),
        startTime: String(data.startTime || '00:00').trim(),
        endTime: String(data.endTime || '23:59').trim(),
        status: String(data.status || 'scheduled').trim(),
        description: String(data.description || '').trim(),
        mechanics: String(data.mechanics || '').trim(),
        promotionMechanicType: String(data.promotionMechanicType || 'multiplier').trim(),
        discountValueType: String(data.discountValueType || 'fixed_amount').trim(),
        linkedRewardId: String(data.linkedRewardId || '').trim(),
    })

    const normalizeLinkedItemRows = (rows = []) =>
        rows
            .filter((row) => row.item_id)
            .map((row) => `${row.item_id}:${row.variant_id || ''}`)
            .sort()

    //Change Detector
    const hasAddTierChanges =
        JSON.stringify(normalizeTierFormData(tierFormData)) !==
        JSON.stringify(normalizeTierFormData({ name: '', minPoints: '', maxPoints: '', benefits: [''] }))

    const hasEditTierChanges =
        initialTierFormData !== null &&
        (
            JSON.stringify(normalizeTierFormData(tierFormData)) !==
            JSON.stringify(normalizeTierFormData(initialTierFormData)) ||
            tierImageFile !== null
        )

    const hasAddAchievementChanges =
        JSON.stringify(normalizeAchievementFormData(achievementFormData)) !==
        JSON.stringify(normalizeAchievementFormData({
            title: '',
            description: '',
            rewardPoints: '',
            status: 'active',
            rule_type: 'completed_orders',
            target_value: '',
            category_name: '',
            branch_id: '',
            timeframe_type: 'none',
            condition_label: ''
        }))

    const hasEditAchievementChanges =
        initialAchievementFormData !== null &&
        (
            JSON.stringify(normalizeAchievementFormData(achievementFormData)) !==
            JSON.stringify(normalizeAchievementFormData(initialAchievementFormData)) ||
            achievementImageFile !== null
        )

    const hasAddRewardChanges =
        JSON.stringify(normalizeRewardFormData(rewardFormData)) !==
        JSON.stringify(normalizeRewardFormData({
            name: '',
            description: '',
            mechanics: '',
            pointsRequired: '',
            rewardDurationType: 'Permanent',
            startDate: '',
            endDate: '',
            status: 'active'
        })) ||
        normalizeLinkedItemRows(rewardLinkedItems).length > 0

    const hasEditRewardChanges =
        initialRewardFormData !== null &&
        (
            JSON.stringify(normalizeRewardFormData(rewardFormData)) !==
            JSON.stringify(normalizeRewardFormData(initialRewardFormData)) ||
            !areSetsEqual(selectedBranchIds, initialSelectedBranchIds) ||
            JSON.stringify(normalizeLinkedItemRows(rewardLinkedItems)) !==
            JSON.stringify(normalizeLinkedItemRows(initialRewardLinkedItems))
        )

    const hasAddCampaignChanges =
        JSON.stringify(normalizeCampaignFormData(campaignFormData)) !==
        JSON.stringify(normalizeCampaignFormData({
            name: '',
            type: 'Promotion',
            startDate: '',
            endDate: '',
            status: 'scheduled',
            description: '',
            mechanics: '',
            linkedRewardId: ''
        }))

    const hasEditCampaignChanges =
        initialCampaignFormData !== null &&
        (
            JSON.stringify(normalizeCampaignFormData(campaignFormData)) !==
            JSON.stringify(normalizeCampaignFormData(initialCampaignFormData)) ||
            !areSetsEqual(selectedBranchIds, initialSelectedBranchIds)
        )

    // ─── Effects ────────────────────────────────────────────────────────────
    useEffect(() => {
        const style = document.createElement('style')
        style.innerHTML = `
            .swal2-confirm { background-color: #8B5A3C !important; border: none !important; }
            .swal2-confirm:hover { background-color: #6d4730 !important; }
            .swal2-cancel { background-color: #6b7280 !important; border: none !important; }
            .swal2-cancel:hover { background-color: #5a5a5a !important; }
        `
        document.head.appendChild(style)
        return () => document.head.removeChild(style)
    }, [])

    useEffect(() => {
        fetchCampaigns()

        const interval = setInterval(() => {
            fetchCampaigns()
        }, 60 * 1000)

        return () => clearInterval(interval)
    }, [])

    useEffect(() =>
        setTierPage(1), [tierSearch])

    useEffect(() =>
        setAchievementPage(1), [achievementSearch, achievementView])

    useEffect(() =>
        setRewardPage(1), [rewardSearch, rewardView, rewardAvailabilityFilter])

    useEffect(() =>
        setCampaignPage(1), [campaignSearch, campaignView])

    useEffect(() =>
        setRewardLinkedItemPickerPage(1), [linkedItemSearch])

    useEffect(() =>
        setCampaignRewardPickerPage(1), [campaignRewardSearch])

    useEffect(() =>
        setArchivedPage(1), [archivedSearch, archivedCampaignTypeFilter, archivedAchievementTypeFilter, archivedRewardTypeFilter])

    useEffect(() => {
        loadLoyaltyRewardsData()
    }, [])

    // ─── Pagination  ─────────────────────────────────────────────
        function Pagination({ page, totalItems, pageSize, onPageChange }) {
        const totalPages = Math.ceil(totalItems / pageSize)
        if (totalItems === 0) return null

        return (
            <div className="flex items-center justify-between px-4 py-2 rounded-b-xl"
            >
                <span style={{ fontSize: 14, color: C.midgrey }}>
                    Showing <span className="font-medium text-gray-700">{Math.min((page - 1) * pageSize + 1, totalItems)}–{Math.min(page * pageSize, totalItems)}</span> of <span className="font-medium text-gray-700">{totalItems}</span> items
                </span>
                {totalPages > 1 && (
                    <div className="flex items-center gap-1">
                        <button
                            onClick={() => onPageChange(Math.max(1, page - 1))}
                            disabled={page === 1}
                            style={{
                                padding: "3px 10px", borderRadius: 8,
                                border: `1px solid ${C.border}`, background: C.card,
                                color: page === 1 ? C.border : C.textSoft,
                                fontSize: 14, cursor: page === 1 ? "not-allowed" : "pointer",
                            }}>
                            ← Prev
                        </button>
                        {Array.from({ length: totalPages }, (_, i) => i + 1)
                            .filter(n => n === 1 || n === totalPages || Math.abs(n - page) <= 1)
                            .reduce((acc, n, idx, arr) => {
                                if (idx > 0 && n - arr[idx - 1] > 1) acc.push("…")
                                acc.push(n)
                                return acc
                            }, [])
                            .map((n, idx) =>
                                n === "…" ? (
                                    <span key={`e-${idx}`} style={{ fontSize: 16, color: C.midgrey, padding: "0 2px" }}>…</span>
                                ) : (
                                    <button key={n} onClick={() => onPageChange(n)}
                                        style={{
                                            width: 28, height: 28, borderRadius: 8,
                                            border: `1px solid ${n === page ? C.nude : C.border}`,
                                            background: n === page ? C.nude : C.card,
                                            color: n === page ? "#fff" : C.textSoft,
                                            fontSize: 14, fontWeight: n === page ? 600 : 400,
                                            cursor: "pointer",
                                        }}>
                                        {n}
                                    </button>
                                )
                            )
                        }
                        <button
                            onClick={() => onPageChange(Math.min(totalPages, page + 1))}
                            disabled={page === totalPages}
                            style={{
                                padding: "3px 10px", borderRadius: 8,
                                border: `1px solid ${C.border}`, background: C.card,
                                color: page === totalPages ? C.border : C.textSoft,
                                fontSize: 14, cursor: page === totalPages ? "not-allowed" : "pointer",
                            }}>
                            Next →
                        </button>
                    </div>
                )}
            </div>
        )
    }

    //Archive & Reinstate
    const handleArchiveTier = async (tierId, tierName) => {
        const result = await Swal.fire({
            title: 'Archive Tier?',
            text: `"${tierName}" will be removed from the active tier list.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d97706',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Yes, archive',
            cancelButtonText: 'Cancel'
        })

        if (!result.isConfirmed) return

        try {
            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/tiers/${tierId}/archive`, { method: 'PATCH', headers: authHeaders() })
            const data = await res.json()
            if (!res.ok) throw new Error(data.error)

            setCustomerTiers((prev) => prev.filter((t) => t.id !== tierId))

            Swal.fire({
                icon: 'success',
                title: 'Tier Archived',
                text: `${tierName} has been archived.`,
                confirmButtonColor: '#8B5A3C',
                timer: 1800
            })
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Failed to Archive Tier',
                text: err.message,
                confirmButtonColor: '#8B5A3C'
            })
        }
    }

    const handleReinstateTier = async (tier) => {
        try {
            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/tiers/${tier.tier_id}/reinstate`, { method: 'PATCH', headers: authHeaders() })
            const data = await res.json()
            if (!res.ok) throw new Error(data.error)

            await loadLoyaltyRewardsData()

            Swal.fire({
                icon: 'success',
                title: 'Tier Reinstated',
                text: `${tier.tier_name} is active again.`,
                confirmButtonColor: '#8B5A3C',
                timer: 1800
            })
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Failed to Reinstate Tier',
                text: err.message,
                confirmButtonColor: '#8B5A3C'
            })
        }
    }

    const handleArchiveReward = async (rewardId, rewardName) => {
        const result = await Swal.fire({
            title: 'Archive Reward?',
            text: `"${rewardName}" will be removed from the active rewards list.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d97706',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Yes, archive',
            cancelButtonText: 'Cancel'
        })
        if (!result.isConfirmed) return

        try {
            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/rewards/${rewardId}/archive`, { method: 'PATCH', headers: authHeaders() })
            const data = await res.json()
            if (!res.ok) throw new Error(data.error)
            await loadLoyaltyRewardsData()
            Swal.fire({ icon: 'success', title: 'Reward Archived', confirmButtonColor: '#8B5A3C', timer: 1500 })
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Archive Reward', text: err.message, confirmButtonColor: '#8B5A3C' })
        }
    }

    const handleReinstateReward = async (rewardId) => {
        try {
            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/rewards/${rewardId}/reinstate`, { method: 'PATCH', headers: authHeaders() })
            const data = await res.json()
            if (!res.ok) throw new Error(data.error)

            await loadLoyaltyRewardsData()

            Swal.fire({
                icon: 'success',
                title: 'Reward Restored',
                confirmButtonColor: '#8B5A3C',
                timer: 1500
            })
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Failed to Reinstate Reward',
                text: err.message,
                confirmButtonColor: '#8B5A3C'
            })
        }
    }

    const handleArchiveCampaign = async (campaignId, campaignName) => {
        const result = await Swal.fire({
            title: 'Archive Campaign?',
            text: `"${campaignName}" will be removed from the active campaign list.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d97706',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Yes, archive',
            cancelButtonText: 'Cancel'
        })
        if (!result.isConfirmed) return

        try {
            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/campaigns/${campaignId}/archive`, { method: 'PATCH', headers: authHeaders() })
            const data = await res.json()
            if (!res.ok) throw new Error(data.error)
            await fetchCampaigns()
            await loadLoyaltyRewardsData()
            Swal.fire({ icon: 'success', title: 'Campaign Archived', confirmButtonColor: '#8B5A3C', timer: 1500 })
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Archive Campaign', text: err.message, confirmButtonColor: '#8B5A3C' })
        }
    }

    const handleReinstateCampaign = async (campaignId) => {
        try {
            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/campaigns/${campaignId}/reinstate`, { method: 'PATCH', headers: authHeaders() })
            const data = await res.json()
            if (!res.ok) throw new Error(data.error)

            await fetchCampaigns()
            await loadLoyaltyRewardsData()

            Swal.fire({
                icon: 'success',
                title: 'Campaign Restored',
                confirmButtonColor: '#8B5A3C',
                timer: 1500
            })
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Failed to Reinstate Campaign',
                text: err.message,
                confirmButtonColor: '#8B5A3C'
            })
        }
    }

    const handleArchiveAchievement = async (achievementId, achievementTitle) => {
        const result = await Swal.fire({
            title: 'Archive Achievement?',
            text: `"${achievementTitle}" will be removed from the active achievement list.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d97706',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Yes, archive',
            cancelButtonText: 'Cancel'
        })
        if (!result.isConfirmed) return

        try {
            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/achievements/${achievementId}/archive`, { method: 'PATCH', headers: authHeaders() })
            const data = await res.json()
            if (!res.ok) throw new Error(data.error)
            await loadLoyaltyRewardsData()
            Swal.fire({ icon: 'success', title: 'Achievement Archived', confirmButtonColor: '#8B5A3C', timer: 1500 })
        } catch (err) {
            Swal.fire({ icon: 'error', title: 'Failed to Archive Achievement', text: err.message, confirmButtonColor: '#8B5A3C' })
        }
    }

    const handleReinstateAchievement = async (achievementId) => {
        try {
            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/achievements/${achievementId}/reinstate`, { method: 'PATCH', headers: authHeaders() })
            const data = await res.json()
            if (!res.ok) throw new Error(data.error)

            await loadLoyaltyRewardsData()

            Swal.fire({
                icon: 'success',
                title: 'Achievement Restored',
                confirmButtonColor: '#8B5A3C',
                timer: 1500
            })
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Failed to Reinstate Achievement',
                text: err.message,
                confirmButtonColor: '#8B5A3C'
            })
        }
    }

    const toggleBranchSelection = (branchId) => {
        setSelectedBranchIds((prev) => {
            const next = new Set(prev)
            if (next.has(branchId)) {
                next.delete(branchId)
            } else {
                next.add(branchId)
            }
            return next
        })
    }

    const allActiveBranchIds = branches.map((branch) => branch.branch_id)

    const areAllBranchesSelected =
        branches.length > 0 && selectedBranchIds.size === branches.length

    const handleSelectAllBranches = () => {
        setSelectedBranchIds(new Set(allActiveBranchIds))
    }

    const handleClearAllBranches = () => {
        setSelectedBranchIds(new Set())
    }

    const handleToggleSelectAllBranches = () => {
        if (areAllBranchesSelected) {
            handleClearAllBranches()
        } else {
            handleSelectAllBranches()
        }
    }

    //Auto archive
    const today = new Date()

    const activeRewardsList = rewardsCatalog.filter(
        (reward) =>
            !(
                reward.rewardDurationType === 'Limited' &&
                reward.endDate &&
                new Date(reward.endDate) < today
            )
    )

    const completedRewardsList = rewardsCatalog.filter(
        (reward) =>
            reward.rewardDurationType === 'Limited' &&
            reward.endDate &&
            new Date(reward.endDate) < today
    )

    const activeCampaignsList = activeCampaigns.filter(
        (campaign) =>
            !(campaign.endDate && new Date(campaign.endDate) < today)
    )

    const completedCampaignsList = activeCampaigns.filter(
        (campaign) =>
            campaign.endDate &&
            new Date(campaign.endDate) < today
    )

    const archivedRewardsList = archivedRewards
    const archivedCampaignsList = archivedCampaigns
    const archivedAchievementsList = archivedAchievements

    // Achievement view toggle removed — the tab now always shows every non-archived
    // achievement (active + inactive). Archived items live in the Archived Viewer modal.
    const visibleAchievements = achievements

    const visibleRewards =
        rewardView === 'archived'
            ? archivedRewardsList
            : rewardView === 'completed'
                ? completedRewardsList
                : activeRewardsList

    const visibleCampaigns =
        campaignView === 'archived'
            ? archivedCampaignsList
            : campaignView === 'completed'
                ? completedCampaignsList
                : activeCampaignsList

    const loyaltyStats = useMemo(() => {
        const totalMembers = activeMembersCount
        const totalCampaigns = activeCampaigns.filter((campaign) => campaign.status === 'active').length
        const totalRewards = activeRewardsList.length
        const activeAchievements = achievements.filter((achievement) => achievement.status === 'active').length

        return {
            totalMembers,
            totalCampaigns,
            totalRewards,
            activeAchievements
        }
    }, [activeMembersCount, activeCampaigns, rewardsCatalog, achievements])

    const formatTimeAgo = (dateString) => {
        const now = new Date()
        const date = new Date(dateString)
        const diffInMinutes = Math.floor((now - date) / 60000)

        if (diffInMinutes < 1) return 'Just now'
        if (diffInMinutes < 60) return `${diffInMinutes} min ago`

        const diffInHours = Math.floor(diffInMinutes / 60)
        if (diffInHours < 24) return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`

        const diffInDays = Math.floor(diffInHours / 24)
        return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`
    }

    const getCampaignStatusColor = (status) => {
        switch (status) {
            case 'active':
                return 'bg-green-100 text-green-800'
            case 'scheduled':
                return 'bg-blue-100 text-blue-800'
            case 'inactive':
                return 'bg-yellow-100 text-yellow-800'
            case 'completed':
                return 'bg-purple-100 text-purple-800'
            default:
                return 'bg-gray-100 text-gray-800'
        }
    }

    const getLiveStatusColor = (isActive) => {
        return isActive
            ? 'bg-green-100 text-green-800'
            : 'bg-red-100 text-red-800'
    }

    const getAchievementStatusColor = (status) => {
        switch (status) {
            case 'active':
                return 'bg-green-100 text-green-800'
            case 'inactive':
                return 'bg-yellow-100 text-yellow-800'
            default:
                return 'bg-gray-100 text-gray-800'
        }
    }

    const getRedemptionStatusColor = (status) => {
        switch (status) {
            case 'completed':
                return 'bg-green-100 text-green-800'
            case 'pending':
                return 'bg-yellow-100 text-yellow-800'
            case 'cancelled':
                return 'bg-red-100 text-red-800'
            default:
                return 'bg-gray-100 text-gray-800'
        }
    }

    const resetTierForm = () => {
        setTierFormData({
            name: '',
            minPoints: '',
            maxPoints: '',
            benefits: ['']
        })
        setTierImageFile(null)
        setTierImageInputMode('upload')
        setInitialTierFormData(null)
    }

    const resetAchievementForm = () => {
        setAchievementFormData({
            title: '',
            description: '',
            rewardPoints: '',
            status: 'active',
            image_url: '',
            rule_type: 'completed_orders',
            target_value: '',
            category_name: '',
            branch_id: '',
            timeframe_type: 'none',
            condition_label: ''
        })
        setAchievementImageFile(null)
        setAchievementImageInputMode('upload')
        setInitialAchievementFormData(null)
    }

    const resetRewardForm = () => {
        setRewardFormData({
            name: '',
            type: '',
            reward_logic_type: 'point',

            description: '',
            points_required: '',
            reward_value: '',
            max_discount_amount: '',

            stock_quantity: '',
            start_at: '',
            end_at: '',
            is_featured: false,
            mechanics: '',
            minimum_spend: '',
            min_order_count: '',
            min_total_spent: '',
            bonus_points: '',
            promo_min_order_count: '',
            application_scope: 'all',
            applies_to_category: '',

            achievement_id: '',
            linked_item_id: '',
            linked_variant_id: ''
        })
        setLinkedItemSearch('')
        setSelectedBranchIds(new Set())
        setInitialSelectedBranchIds(new Set())
        setRewardAchievementSearch('')
        setRewardLinkedItems([])
        setLinkedItemSearch('')
        setInitialRewardFormData(null)
        setInitialRewardLinkedItems([])
    }

    const resetCampaignForm = () => {
        setCampaignFormData({
            name: '',
            type: 'Promotion',
            startDate: '',
            endDate: '',
            startTime: '00:00',
            endTime: '23:59',
            status: 'scheduled',
            description: '',
            mechanics: '',
            linkedRewardId: '',
        })
        setCampaignRewardSearch('')
        setSelectedBranchIds(new Set())
        setInitialSelectedBranchIds(new Set())
        setInitialCampaignFormData(null)
    }

    const openAddTierModal = () => {
        setEditingTier(null)
        resetTierForm()
        setShowAddTierModal(true)
    }

    const openEditTierModal = (tier) => {
        const normalizedTier = {
            name: String(tier.name || ''),
            minPoints: String(tier.minPoints ?? ''),
            maxPoints: tier.maxPoints === null ? '' : String(tier.maxPoints),
            benefits: tier.benefits?.length ? [...tier.benefits] : [''],
            image_url: String(tier.image_url || '')
        }

        setEditingTier(tier)
        setTierFormData(normalizedTier)
        setInitialTierFormData(normalizedTier)
        setTierImageFile(null)
        setTierImageInputMode(tier.image_url ? 'url' : 'upload')
        setShowEditTierModal(true)
    }

    const openAddAchievementModal = () => {
        setEditingAchievement(null)
        resetAchievementForm()
        setShowAddAchievementModal(true)
    }

    const openEditAchievementModal = (achievement) => {
        const normalizedAchievement = {
            title: String(achievement.title || ''),
            description: String(achievement.description || ''),
            rewardPoints: String(achievement.rewardPoints ?? ''),
            status: String(achievement.status || 'active'),
            image_url: String(achievement.image_url || ''),
            rule_type: achievement.ruleType || 'completed_orders',
            target_value: String(achievement.targetValue ?? ''),
            category_name: achievement.categoryName || '',
            branch_id: achievement.branchId || '',
            timeframe_type: achievement.timeframeType || 'none',
            condition_label: achievement.condition || ''
        }

        setEditingAchievement(achievement)
        setAchievementFormData(normalizedAchievement)
        setInitialAchievementFormData(normalizedAchievement)
        setAchievementImageFile(null)
        setAchievementImageInputMode(achievement.image_url ? 'url' : 'upload')
        setShowEditAchievementModal(true)
    }

    const openAddRewardModal = () => {
        setEditingReward(null)
        resetRewardForm()
        setShowAddRewardModal(true)
    }

    const openEditRewardModal = async (reward) => {
        const normalizedReward = {
            name: String(reward.name || ''),
            reward_logic_type: String(reward.rewardLogicType || 'point'),
            description: String(reward.description || ''),
            mechanics: String(reward.mechanics || ''),
            minimum_spend: reward.minimumSpend !== undefined && reward.minimumSpend !== null
                ? String(reward.minimumSpend)
                : '',
            points_required: String(reward.pointsRequired ?? ''),
            reward_value_type: reward.rewardValueType || '',
            reward_value: reward.rewardValue !== '' && reward.rewardValue != null
                ? String(reward.rewardValue)
                : '',
            max_discount_amount: reward.maxDiscountAmount !== '' && reward.maxDiscountAmount != null
                ? String(reward.maxDiscountAmount)
                : '',
            bonus_points: reward.bonusPoints !== undefined && reward.bonusPoints !== null
                ? String(reward.bonusPoints)
                : '',
            promo_min_order_count: reward.promoMinOrderCount !== undefined && reward.promoMinOrderCount !== null
                ? String(reward.promoMinOrderCount)
                : '',
            rewardDurationType: String(reward.rewardDurationType || 'Permanent'),
            startDate: String(reward.startDate || ''),
            endDate: String(reward.endDate || ''),
            status: String(reward.status || 'active'),
            linked_item_id: reward.linkedItemId || '',
            linked_variant_id: reward.linkedVariantId || '',
            application_scope: reward.applicationScope || 'all',
            applies_to_category: reward.appliesToCategory || '',
            is_featured: reward.isFeatured || false,
        }

        setEditingReward(reward)
        setRewardFormData(normalizedReward)
        setInitialRewardFormData(normalizedReward)

        try {
            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/rewards/${reward.id}/edit-context`, { headers: authHeaders() })
            const ctx = await res.json()
            if (!res.ok) throw new Error(ctx.error)

            const branchSet = new Set(ctx.branchIds || [])
            setSelectedBranchIds(branchSet)
            setInitialSelectedBranchIds(new Set(branchSet))

            const orderCountRule = (ctx.rules || []).find((r) => r.rule_type === 'completed_orders')
            const minSpendRule = (ctx.rules || []).find((r) => r.rule_type === 'minimum_spend')
            const achievementRule = (ctx.rules || []).find((r) => r.rule_type === 'achievement_required')

            const ruleUpdates = {
                min_order_count: orderCountRule ? String(orderCountRule.target_value ?? '') : '',
                min_total_spent: minSpendRule ? String(minSpendRule.target_value ?? '') : '',
                achievement_id: achievementRule ? achievementRule.achievement_id || '' : ''
            }

            setRewardFormData((prev) => ({ ...prev, ...ruleUpdates }))
            setInitialRewardFormData((prev) => ({ ...prev, ...ruleUpdates }))

            const linkedItemsRows = (ctx.linkedItems || []).map((row) => ({
                item_id: row.item_id,
                variant_id: row.variant_id || ''
            }))

            setRewardLinkedItems(linkedItemsRows)
            setInitialRewardLinkedItems(linkedItemsRows)

            setShowEditRewardModal(true)
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Failed to Load Reward Details',
                text: err.message,
                confirmButtonColor: '#8B5A3C'
            })
        }
    }

    const openAddCampaignModal = () => {
        setEditingCampaign(null)
        resetCampaignForm()
        setShowAddCampaignModal(true)
    }

    const openEditCampaignModal = async (campaign) => {
        const normalizedCampaign = {
            name: String(campaign.name || ''),
            type: String(campaign.type || 'Promotion'),
            startDate: String(campaign.startDate || ''),
            endDate: String(campaign.endDate || ''),
            startTime: String(campaign.startTime || '00:00'),
            endTime: String(campaign.endTime || '23:59'),
            status: String(campaign.status || 'scheduled'),
            description: String(campaign.description || ''),
            mechanics: String(campaign.mechanics || ''),
            minOrderCount: String(campaign.minOrderCount || ''),
            minimumSpend: String(campaign.minimumSpend || ''),
            linkedRewardId: campaign.linkedRewardId || '',
        }

        setEditingCampaign(campaign)
        setCampaignFormData(normalizedCampaign)
        setInitialCampaignFormData(normalizedCampaign)
        setCampaignRewardSearch('')

        try {
            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/campaigns/${campaign.id}/branches`, { headers: authHeaders() })
            const data = await res.json()
            if (!res.ok) throw new Error(data.error)

            const branchSet = new Set(data.branchIds || [])
            setSelectedBranchIds(branchSet)
            setInitialSelectedBranchIds(new Set(branchSet))
            setShowEditCampaignModal(true)
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Failed to Load Campaign Branches',
                text: err.message,
                confirmButtonColor: '#8B5A3C'
            })
        }
    }

    const openCampaignDetailsModal = (campaign) => {
        setViewingCampaign(campaign)
        setShowCampaignDetailsModal(true)
    }

    const closeCampaignDetailsModal = () => {
        setShowCampaignDetailsModal(false)
        setViewingCampaign(null)
    }

    const openArchivedViewerModal = (tab) => {
        setArchivedViewerTab(tab)
        setArchivedSearch('')
        setArchivedPage(1)
        setArchivedCampaignTypeFilter('All')
        setArchivedAchievementTypeFilter('All')
        setArchivedRewardTypeFilter('All')
        setShowArchivedViewerModal(true)
        loadLoyaltyRewardsData()
    }

    const closeArchivedViewerModal = () => {
        setShowArchivedViewerModal(false)
    }

    const handleBenefitChange = (index, value) => {
        setTierFormData((prev) => {
            const updatedBenefits = [...prev.benefits]
            updatedBenefits[index] = value
            return { ...prev, benefits: updatedBenefits }
        })
    }

    const addBenefitField = () => {
        setTierFormData((prev) => ({
            ...prev,
            benefits: [...prev.benefits, '']
        }))
    }

    const removeBenefitField = (index) => {
        setTierFormData((prev) => {
            const updatedBenefits = prev.benefits.filter((_, idx) => idx !== index)
            return {
                ...prev,
                benefits: updatedBenefits.length ? updatedBenefits : ['']
            }
        })
    }

    const validateTierForm = () => {
        if (!tierFormData.name.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'Tier name is required.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (tierFormData.name.trim().length > MAX_LENGTHS.tierName) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Tier Name',
                text: `Tier name must not exceed ${MAX_LENGTHS.tierName} characters.`,
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (tierFormData.minPoints === '' || Number(tierFormData.minPoints) < 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Minimum Points',
                text: 'Minimum points is required and must be 0 or higher.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (tierFormData.maxPoints !== '' && Number(tierFormData.maxPoints) < Number(tierFormData.minPoints)) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Maximum Points',
                text: 'Maximum points must not be lower than minimum points.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        const benefits = normalizeArrayStrings(tierFormData.benefits)
        if (benefits.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Benefits',
                text: 'Please add at least one benefit.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        const benefitTooLong = benefits.find(b => b.length > MAX_LENGTHS.benefit)
        if (benefitTooLong) {
            Swal.fire({
                icon: 'warning',
                title: 'Benefit Too Long',
                text: `Each benefit must not exceed ${MAX_LENGTHS.benefit} characters.`,
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (!Number.isInteger(Number(tierFormData.minPoints))) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Minimum Points',
                text: 'Minimum points must be a whole number.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (tierFormData.maxPoints !== '' && !Number.isInteger(Number(tierFormData.maxPoints))) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Maximum Points',
                text: 'Maximum points must be a whole number.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        return true
    }

    const validateAchievementForm = () => {
        if (!achievementFormData.title.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'Achievement title is required.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (achievementFormData.title.trim().length > MAX_LENGTHS.achievementTitle) {
            Swal.fire({
                icon: 'warning',
                title: 'Title Too Long',
                text: `Achievement title must not exceed ${MAX_LENGTHS.achievementTitle} characters.`,
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (!achievementFormData.description.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'Achievement description is required.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (achievementFormData.description.trim().length > MAX_LENGTHS.achievementDescription) {
            Swal.fire({
                icon: 'warning',
                title: 'Description Too Long',
                text: `Achievement description must not exceed ${MAX_LENGTHS.achievementDescription} characters.`,
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (achievementFormData.rewardPoints === '' || Number(achievementFormData.rewardPoints) < 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Reward Points',
                text: 'Reward points is required and must be 0 or higher.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (!Number.isInteger(Number(achievementFormData.rewardPoints))) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Reward Points',
                text: 'Reward points must be a whole number.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (!Number.isInteger(Number(achievementFormData.target_value))) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Target Value',
                text: 'Target value must be a whole number.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (!achievementFormData.target_value || Number(achievementFormData.target_value) < 1) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Target',
                text: 'Target value must be at least 1.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }
        if (achievementFormData.rule_type === 'category_orders' && !achievementFormData.category_name) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Category',
                text: 'Please select a category.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }
        if (!achievementFormData.condition_label.trim()) {
            const autoLabel = generateConditionLabel(achievementFormData)
            if (!autoLabel) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Missing Condition Label',
                    text: 'Please fill in the rule fields so a condition label can be generated.',
                    confirmButtonColor: '#8B5A3C'
                })
                return false
            }
        }
        return true
    }

    const validateRewardForm = () => {
        if (!rewardFormData.name.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'Reward name is required.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (rewardFormData.name.trim().length > MAX_LENGTHS.rewardName) {
            Swal.fire({
                icon: 'warning',
                title: 'Reward Name Too Long',
                text: `Reward name must not exceed ${MAX_LENGTHS.rewardName} characters.`,
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (!rewardFormData.description.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'Reward description is required.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (rewardFormData.description.trim().length > MAX_LENGTHS.rewardDescription) {
            Swal.fire({
                icon: 'warning',
                title: 'Description Too Long',
                text: `Reward description must not exceed ${MAX_LENGTHS.rewardDescription} characters.`,
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (!rewardFormData.mechanics.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Mechanics',
                text: 'Reward mechanics are required.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (rewardFormData.mechanics.trim().length > MAX_LENGTHS.rewardGuidelines) {
            Swal.fire({
                icon: 'warning',
                title: 'Mechanics Too Long',
                text: `Reward mechanics must not exceed ${MAX_LENGTHS.rewardGuidelines} characters.`,
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (
            rewardFormData.reward_logic_type !== 'achievement' &&
            !rewardFormData.reward_value_type
        ) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Reward Value Type',
                text: 'Please select a reward value type.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (
            rewardFormData.reward_value_type &&
            !rewardFormData.reward_value
        ) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Reward Value',
                text: 'Please enter a reward value.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (
            rewardFormData.reward_value_type === 'percentage' &&
            rewardFormData.reward_value > 100
        ) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Percentage',
                text: 'Percentage cannot exceed 100%.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (
            rewardFormData.reward_value_type === 'percentage' &&
            rewardFormData.max_discount_amount !== '' &&
            Number(rewardFormData.max_discount_amount) < 0
        ) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Discount Cap',
                text: 'Max discount cap cannot be negative.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        // Only validate points_required for point-type rewards
        if (rewardFormData.reward_logic_type === 'point') {
            if (rewardFormData.points_required === '' || Number(rewardFormData.points_required) < 0) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Invalid Points Required',
                    text: 'Points required must be 0 or higher.',
                    confirmButtonColor: '#8B5A3C'
                })
                return false
            }
        }

        if (rewardFormData.reward_logic_type === 'achievement') {
            if (!rewardFormData.achievement_id) {
                Swal.fire({
                    icon: 'warning',
                    title: 'No Achievement Selected',
                    text: 'Please select the required achievement.',
                    confirmButtonColor: '#8B5A3C'
                })
                return false
            }
        }

        if (rewardFormData.rewardDurationType === 'Limited') {
            if (!rewardFormData.startDate || !rewardFormData.endDate) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Missing Reward Schedule',
                    text: 'Limited rewards must have a start date and end date.',
                    confirmButtonColor: '#8B5A3C'
                })
                return false
            }

            if (new Date(rewardFormData.endDate) < new Date(rewardFormData.startDate)) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Invalid Reward Date Range',
                    text: 'Reward end date must be after or equal to the start date.',
                    confirmButtonColor: '#8B5A3C'
                })
                return false
            }
        }

        if (
            rewardFormData.minimum_spend !== '' &&
            rewardFormData.minimum_spend != null &&
            Number(rewardFormData.minimum_spend) < 0
        ) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Minimum Spend',
                text: 'Minimum spend cannot be negative.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (
            rewardFormData.reward_value_type === 'fixed_amount' &&
            rewardFormData.reward_value !== '' &&
            Number(rewardFormData.reward_value) <= 0
        ) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Reward Value',
                text: 'Fixed amount must be greater than 0.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (
            rewardFormData.reward_value_type === 'bonus_points' &&
            rewardFormData.reward_value !== '' &&
            Number(rewardFormData.reward_value) < 1
        ) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Bonus Points',
                text: 'Bonus points must be at least 1.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (rewardFormData.application_scope === 'category' && !rewardFormData.applies_to_category) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Category',
                text: 'Please select a category this reward applies to.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (
            rewardFormData.application_scope === 'specific_items' &&
            rewardLinkedItems.filter((row) => row.item_id).length === 0
        ) {
            Swal.fire({
                icon: 'warning',
                title: 'No Items Selected',
                text: 'Please link at least one menu item this reward applies to.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        return true
    }

    const validateCampaignForm = () => {
        if (!campaignFormData.name.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'Campaign name is required.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (!campaignFormData.description.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'Campaign description is required.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (!campaignFormData.mechanics.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Mechanics',
                text: 'Campaign mechanics are required.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (!campaignFormData.startDate) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'Start date is required.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (!campaignFormData.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'End date is required.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        const startDateTime = new Date(`${campaignFormData.startDate}T${campaignFormData.startTime || '00:00'}`)
        const endDateTime = new Date(`${campaignFormData.endDate}T${campaignFormData.endTime || '23:59'}`)

        if (endDateTime <= startDateTime) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Date/Time Range',
                text: 'End date/time must be after start date/time.',
                confirmButtonColor: '#8B5A3C'
            })
            return false
        }

        if (campaignFormData.name.trim().length > MAX_LENGTHS.campaignName) {
            Swal.fire({ icon: 'warning', title: 'Campaign Name Too Long', text: `Campaign name must not exceed ${MAX_LENGTHS.campaignName} characters.`, confirmButtonColor: '#8B5A3C' })
            return false
        }

        if (campaignFormData.description.trim().length > MAX_LENGTHS.campaignDescription) {
            Swal.fire({ icon: 'warning', title: 'Description Too Long', text: `Campaign description must not exceed ${MAX_LENGTHS.campaignDescription} characters.`, confirmButtonColor: '#8B5A3C' })
            return false
        }

        if (campaignFormData.mechanics.trim().length > MAX_LENGTHS.campaignGuidelines) {
            Swal.fire({ icon: 'warning', title: 'Mechanics Too Long', text: `Campaign mechanics must not exceed ${MAX_LENGTHS.campaignGuidelines} characters.`, confirmButtonColor: '#8B5A3C' })
            return false
        }

        if (campaignFormData.type === 'Promotion') {

        }

        return true
    }

    const handleAddTier = async () => {
        if (!validateTierForm()) return

        if (checkDuplicateTierName(tierFormData.name)) {
            Swal.fire({
                icon: 'warning',
                title: 'Duplicate Tier Name',
                text: 'A tier with this name already exists.',
                confirmButtonColor: '#8B5A3C'
            })
            return
        }

        try {
            let finalImageUrl = tierFormData.image_url?.trim() || null
            if (tierImageInputMode === 'upload' && tierImageFile) {
                setUploadingTierImage(true)
                finalImageUrl = await uploadTierImage(tierImageFile)
                setUploadingTierImage(false)
            }

            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/tiers`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', ...authHeaders() },
                body: JSON.stringify({
                    name: tierFormData.name,
                    minPoints: tierFormData.minPoints,
                    benefits: tierFormData.benefits,
                    image_url: finalImageUrl
                })
            })
            const uiPayload = await res.json()
            if (!res.ok) throw new Error(uiPayload.error)

            setCustomerTiers((prev) => [
                ...prev,
                { ...uiPayload, maxPoints: tierFormData.maxPoints === '' ? null : Number(tierFormData.maxPoints) }
            ])
            setShowAddTierModal(false)
            resetTierForm()

            Swal.fire({
                icon: 'success',
                title: 'Tier Added!',
                text: `${uiPayload.name} has been added successfully.`,
                confirmButtonColor: '#8B5A3C',
                timer: 1800
            })
        } catch (err) {
            setUploadingTierImage(false)
            Swal.fire({
                icon: 'error',
                title: 'Failed to Add Tier',
                text: err.message,
                confirmButtonColor: '#8B5A3C'
            })
        }
    }

    const handleUpdateTier = async () => {
        if (!editingTier) return
        if (!hasEditTierChanges) return
        if (!validateTierForm()) return

        if (checkDuplicateTierName(tierFormData.name, editingTier?.id)) {
            Swal.fire({
                icon: 'warning',
                title: 'Duplicate Tier Name',
                text: 'A tier with this name already exists.',
                confirmButtonColor: '#8B5A3C'
            })
            return
        }

        try {
            let finalImageUrl = tierFormData.image_url?.trim() || null
            if (tierImageInputMode === 'upload' && tierImageFile) {
                setUploadingTierImage(true)
                finalImageUrl = await uploadTierImage(tierImageFile)
                setUploadingTierImage(false)
            }

            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/tiers/${editingTier.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', ...authHeaders() },
                body: JSON.stringify({
                    name: tierFormData.name,
                    minPoints: tierFormData.minPoints,
                    benefits: tierFormData.benefits,
                    image_url: finalImageUrl
                })
            })
            const updated = await res.json()
            if (!res.ok) throw new Error(updated.error)

            setCustomerTiers((prev) =>
                prev.map((tier) =>
                    tier.id === editingTier.id
                        ? {
                            ...tier,
                            name: updated.name,
                            minPoints: updated.minPoints,
                            maxPoints: tierFormData.maxPoints === '' ? null : Number(tierFormData.maxPoints),
                            benefits: updated.benefits,
                            image_url: updated.image_url || tier.image_url
                        }
                        : tier
                )
            )

            setShowEditTierModal(false)
            setEditingTier(null)
            resetTierForm()

            Swal.fire({
                icon: 'success',
                title: 'Tier Updated!',
                text: `${updated.name} has been updated successfully.`,
                confirmButtonColor: '#8B5A3C',
                timer: 1800
            })
        } catch (err) {
            setUploadingTierImage(false)
            Swal.fire({
                icon: 'error',
                title: 'Failed to Update Tier',
                text: err.message,
                confirmButtonColor: '#8B5A3C'
            })
        }
    }

    const handleAddAchievement = async () => {
        if (!validateAchievementForm()) return

        try {
            let finalImageUrl = achievementFormData.image_url?.trim() || null
            if (achievementImageInputMode === 'upload' && achievementImageFile) {
                setUploadingAchievementImage(true)
                finalImageUrl = await uploadAchievementImage(achievementImageFile)
                setUploadingAchievementImage(false)
            }

            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/achievements`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', ...authHeaders() },
                body: JSON.stringify({ ...achievementFormData, image_url: finalImageUrl })
            })
            const uiPayload = await res.json()
            if (!res.ok) throw new Error(uiPayload.error)

            setAchievements((prev) => [uiPayload, ...prev])
            setShowAddAchievementModal(false)
            resetAchievementForm()

            Swal.fire({
                icon: 'success',
                title: 'Achievement Added!',
                text: `${uiPayload.title} has been added successfully.`,
                confirmButtonColor: '#8B5A3C',
                timer: 1800
            })
        } catch (err) {
            setUploadingAchievementImage(false)
            Swal.fire({
                icon: 'error',
                title: 'Failed to Add Achievement',
                text: err.message,
                confirmButtonColor: '#8B5A3C'
            })
        }
    }

    const handleUpdateAchievement = async () => {
        if (!editingAchievement) return
        if (!hasEditAchievementChanges) return
        if (!validateAchievementForm()) return

        try {
            let finalImageUrl = achievementFormData.image_url?.trim() || null
            if (achievementImageInputMode === 'upload' && achievementImageFile) {
                setUploadingAchievementImage(true)
                finalImageUrl = await uploadAchievementImage(achievementImageFile)
                setUploadingAchievementImage(false)
            }

            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/achievements/${editingAchievement.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', ...authHeaders() },
                body: JSON.stringify({
                    ...achievementFormData,
                    image_url: finalImageUrl,
                    ruleId: editingAchievement.ruleId
                })
            })
            const uiPayload = await res.json()
            if (!res.ok) throw new Error(uiPayload.error)

            setAchievements((prev) =>
                prev.map((achievement) =>
                    achievement.id === editingAchievement.id ? uiPayload : achievement
                )
            )

            setShowEditAchievementModal(false)
            setEditingAchievement(null)
            resetAchievementForm()

            Swal.fire({
                icon: 'success',
                title: 'Achievement Updated!',
                text: `${uiPayload.title} has been updated successfully.`,
                confirmButtonColor: '#8B5A3C',
                timer: 1800
            })
        } catch (err) {
            setUploadingAchievementImage(false)
            Swal.fire({
                icon: 'error',
                title: 'Failed to Update Achievement',
                text: err.message,
                confirmButtonColor: '#8B5A3C'
            })
        }
    }

    const handleAddReward = async () => {
        if (!validateRewardForm()) return

        if (selectedBranchIds.size === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No Branch Selected',
                text: 'Please select at least one branch where this reward is available.',
                confirmButtonColor: '#8B5A3C'
            })
            return
        }

        try {
            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/rewards`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', ...authHeaders() },
                body: JSON.stringify({
                    ...rewardFormData,
                    branchIds: Array.from(selectedBranchIds),
                    linkedItems: rewardLinkedItems
                })
            })
            const uiPayload = await res.json()
            if (!res.ok) throw new Error(uiPayload.error)

            setRewardsCatalog((prev) => [uiPayload, ...prev])
            setShowAddRewardModal(false)
            resetRewardForm()

            Swal.fire({
                icon: 'success',
                title: 'Reward Added!',
                text: `${uiPayload.name} has been added successfully.`,
                confirmButtonColor: '#8B5A3C',
                timer: 1800
            })
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Failed to Add Reward',
                text: err.message,
                confirmButtonColor: '#8B5A3C'
            })
        }
    }

    const handleUpdateReward = async () => {
        if (!editingReward) return
        if (!hasEditRewardChanges) return
        if (!validateRewardForm()) return

        if (selectedBranchIds.size === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No Branch Selected',
                text: 'Please select at least one branch where this reward is available.',
                confirmButtonColor: '#8B5A3C'
            })
            return
        }

        try {
            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/rewards/${editingReward.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', ...authHeaders() },
                body: JSON.stringify({
                    ...rewardFormData,
                    branchIds: Array.from(selectedBranchIds),
                    linkedItems: rewardLinkedItems
                })
            })
            const uiPayload = await res.json()
            if (!res.ok) throw new Error(uiPayload.error)

            setRewardsCatalog((prev) =>
                prev.map((reward) =>
                    reward.id === editingReward.id ? uiPayload : reward
                )
            )

            setShowEditRewardModal(false)
            setEditingReward(null)
            resetRewardForm()

            Swal.fire({
                icon: 'success',
                title: 'Reward Updated!',
                text: `${uiPayload.name} has been updated successfully.`,
                confirmButtonColor: '#8B5A3C',
                timer: 1800
            })
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Failed to Update Reward',
                text: err.message,
                confirmButtonColor: '#8B5A3C'
            })
        }
    }

    const handleAddCampaign = async () => {
        if (!validateCampaignForm()) return

        if (selectedBranchIds.size === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No Branch Selected',
                text: 'Please select at least one branch where this campaign is available.',
                confirmButtonColor: '#8B5A3C'
            })
            return
        }

        try {
            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/campaigns`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', ...authHeaders() },
                body: JSON.stringify({
                    ...campaignFormData,
                    branchIds: Array.from(selectedBranchIds)
                })
            })
            const uiPayload = await res.json()
            if (!res.ok) throw new Error(uiPayload.error)

            setActiveCampaigns((prev) => [uiPayload, ...prev])
            setShowAddCampaignModal(false)
            resetCampaignForm()

            Swal.fire({
                icon: 'success',
                title: 'Campaign Added!',
                text: `${uiPayload.name} has been added successfully.`,
                confirmButtonColor: '#8B5A3C',
                timer: 1800
            })
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Failed to Add Campaign',
                text: err.message,
                confirmButtonColor: '#8B5A3C'
            })
        }
    }

    const handleUpdateCampaign = async () => {
        if (!editingCampaign) return
        if (!hasEditCampaignChanges) return
        if (!validateCampaignForm()) return

        if (selectedBranchIds.size === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No Branch Selected',
                text: 'Please select at least one branch where this campaign is available.',
                confirmButtonColor: '#8B5A3C'
            })
            return
        }

        try {
            const res = await fetch(`${BASE_URL}/api/loyalty-rewards/campaigns/${editingCampaign.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', ...authHeaders() },
                body: JSON.stringify({
                    ...campaignFormData,
                    branchIds: Array.from(selectedBranchIds)
                })
            })
            const uiPayload = await res.json()
            if (!res.ok) throw new Error(uiPayload.error)

            setActiveCampaigns((prev) =>
                prev.map((campaign) =>
                    campaign.id === editingCampaign.id ? uiPayload : campaign
                )
            )

            setShowEditCampaignModal(false)
            setEditingCampaign(null)
            resetCampaignForm()

            Swal.fire({
                icon: 'success',
                title: 'Campaign Updated!',
                text: `${uiPayload.name} has been updated successfully.`,
                confirmButtonColor: '#8B5A3C',
                timer: 1800
            })
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Failed to Update Campaign',
                text: err.message,
                confirmButtonColor: '#8B5A3C'
            })
        }
    }

    // Filter tiers by search
    const filteredTiers = useMemo(() => {
        if (!tierSearch) return customerTiers
        const query = tierSearch.toLowerCase()
        return customerTiers.filter(tier =>
            tier.name.toLowerCase().includes(query) ||
            tier.benefits.some(b => b.toLowerCase().includes(query))
        )
    }, [customerTiers, tierSearch])

    const pagedTiers = filteredTiers.slice((tierPage - 1) * TIER_PAGE_SIZE, tierPage * TIER_PAGE_SIZE)

    // Filter achievements by search
    const filteredAchievements = useMemo(() => {
        if (!achievementSearch) return visibleAchievements
        const query = achievementSearch.toLowerCase()
        return visibleAchievements.filter(achievement =>
            achievement.title.toLowerCase().includes(query) ||
            achievement.description.toLowerCase().includes(query) ||
            achievement.condition.toLowerCase().includes(query)
        )
    }, [visibleAchievements, achievementSearch])

    const pagedAchievements = filteredAchievements.slice((achievementPage - 1) * PAGE_SIZE, achievementPage * PAGE_SIZE)

    // Filter rewards by search and availability
    const filteredRewards = useMemo(() => {
        let results = visibleRewards

        if (rewardAvailabilityFilter !== 'all') {
            results = results.filter(reward =>
                rewardAvailabilityFilter === 'limited'
                    ? reward.rewardDurationType === 'Limited'
                    : reward.rewardDurationType === 'Permanent'
            )
        }

        if (!rewardSearch) return results
        const query = rewardSearch.toLowerCase()
        return results.filter(reward =>
            reward.name.toLowerCase().includes(query) ||
            reward.description.toLowerCase().includes(query) ||
            reward.mechanics.toLowerCase().includes(query)
        )
    }, [visibleRewards, rewardSearch, rewardAvailabilityFilter])

    const pagedRewards = filteredRewards.slice((rewardPage - 1) * PAGE_SIZE, rewardPage * PAGE_SIZE)

    // Filter campaigns by search
    const filteredCampaigns = useMemo(() => {
        if (!campaignSearch) return visibleCampaigns
        const query = campaignSearch.toLowerCase()
        return visibleCampaigns.filter(campaign =>
            campaign.name.toLowerCase().includes(query) ||
            campaign.description.toLowerCase().includes(query) ||
            campaign.mechanics.toLowerCase().includes(query) ||
            campaign.type.toLowerCase().includes(query)
        )
    }, [visibleCampaigns, campaignSearch])

    const pagedCampaigns = filteredCampaigns.slice((campaignPage - 1) * PAGE_SIZE, campaignPage * PAGE_SIZE)

    const availableRewardsForLinking = useMemo(
        () => rewardsCatalog.filter((r) => r.status === 'active'),
        [rewardsCatalog]
    )

    const filteredCampaignRewardOptions = useMemo(() => {
        if (!campaignRewardSearch) return availableRewardsForLinking
        const query = campaignRewardSearch.toLowerCase()
        return availableRewardsForLinking.filter((r) =>
            r.name.toLowerCase().includes(query) ||
            (r.category || '').toLowerCase().includes(query)
        )
    }, [availableRewardsForLinking, campaignRewardSearch])

    const filteredArchivedTiers = useMemo(() => {
        const q = archivedSearch.toLowerCase()
        return archivedTiers.filter(t => String(t.tier_name || '').toLowerCase().includes(q))
    }, [archivedTiers, archivedSearch])
    const pagedArchivedTiers = filteredArchivedTiers.slice((archivedPage - 1) * PAGE_SIZE, archivedPage * PAGE_SIZE)

    const filteredArchivedAchievements = useMemo(() => {
        const q = archivedSearch.toLowerCase()
        return archivedAchievements.filter(a => {
            const matchesSearch =
                String(a.title || '').toLowerCase().includes(q) ||
                String(a.condition || '').toLowerCase().includes(q)

            let matchesType = true
            if (archivedAchievementTypeFilter !== 'All') {
                const [prefix, val] = archivedAchievementTypeFilter.split(':')
                if (prefix === 'rule') {
                    matchesType = a.ruleType === val
                } else if (prefix === 'timeframe') {
                    matchesType = val === 'none'
                        ? (a.timeframeType || 'none') === 'none'
                        : !!a.timeframeType && a.timeframeType !== 'none'
                }
            }
            return matchesSearch && matchesType
        })
    }, [archivedAchievements, archivedSearch, archivedAchievementTypeFilter])

    const pagedArchivedAchievements = filteredArchivedAchievements.slice((archivedPage - 1) * PAGE_SIZE, archivedPage * PAGE_SIZE)

    const filteredArchivedRewards = useMemo(() => {
        const q = archivedSearch.toLowerCase()
        return archivedRewards.filter(r => {
            const matchesSearch = String(r.name || '').toLowerCase().includes(q)

            let matchesType = true
            if (archivedRewardTypeFilter !== 'All') {
                const [prefix, val] = archivedRewardTypeFilter.split(':')
                if (prefix === 'logic') matchesType = r.rewardLogicType === val
                else if (prefix === 'value') matchesType = r.rewardValueType === val
                else if (prefix === 'duration') matchesType = r.rewardDurationType === val
            }
            return matchesSearch && matchesType
        })
    }, [archivedRewards, archivedSearch, archivedRewardTypeFilter])

    const pagedArchivedRewards = filteredArchivedRewards.slice((archivedPage - 1) * PAGE_SIZE, archivedPage * PAGE_SIZE)

    const filteredArchivedCampaigns = useMemo(() => {
        const q = archivedSearch.toLowerCase()
        return archivedCampaigns.filter(c => {
            const matchesSearch = String(c.name || '').toLowerCase().includes(q)
            const matchesType = archivedCampaignTypeFilter === 'All' || c.type === archivedCampaignTypeFilter
            return matchesSearch && matchesType
        })
    }, [archivedCampaigns, archivedSearch, archivedCampaignTypeFilter])
    const pagedArchivedCampaigns = filteredArchivedCampaigns.slice((archivedPage - 1) * PAGE_SIZE, archivedPage * PAGE_SIZE)

    const renderRewardPicker = () => {
        const selectedReward = rewardsCatalog.find((r) => r.id === campaignFormData.linkedRewardId)

        return (
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Linked Reward <span className="text-xs text-gray-500">(optional — leave blank for no reward)</span>
                </label>

                {selectedReward ? (
                    <div className="flex items-center justify-between px-3 py-2 border border-[#8B5A3C] bg-[#F3EAE4] rounded-lg">
                        <div>
                            <p className="text-sm font-medium text-[#8B5A3C]">{selectedReward.name}</p>
                        </div>
                        <button
                            type="button"
                            onClick={() => setCampaignFormData({ ...campaignFormData, linkedRewardId: '' })}
                            className="text-sm font-medium text-red-600 hover:underline"
                        >
                            Remove
                        </button>
                    </div>
                ) : (
                    <div className="space-y-2">
                        <input
                            type="text"
                            value={campaignRewardSearch}
                            onChange={(e) => setCampaignRewardSearch(e.target.value)}
                            placeholder="Search rewards by name..."
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                        />
                        <div className="max-h-48 overflow-y-auto border border-gray-200 rounded-lg divide-y divide-gray-100">
                            {filteredCampaignRewardOptions.length === 0 ? (
                                <div className="px-3 py-3 text-sm text-gray-500">No rewards found.</div>
                            ) : (
                                filteredCampaignRewardOptions
                                    .slice((campaignRewardPickerPage - 1) * PAGE_SIZE, campaignRewardPickerPage * PAGE_SIZE)
                                    .map((r) => (
                                        <button
                                            key={r.id}
                                            type="button"
                                            onClick={() => {
                                                setCampaignFormData({ ...campaignFormData, linkedRewardId: r.id })
                                                setCampaignRewardSearch('')
                                            }}
                                            className="w-full text-left px-3 py-2 hover:bg-gray-50"
                                        >
                                            <p className="text-sm font-medium text-gray-800">{r.name}</p>
                                        </button>
                                    ))
                            )}
                        </div>
                        {filteredCampaignRewardOptions.length > PAGE_SIZE && (
                            <Pagination
                                page={campaignRewardPickerPage}
                                totalItems={filteredCampaignRewardOptions.length}
                                pageSize={PAGE_SIZE}
                                onPageChange={setCampaignRewardPickerPage}
                            />
                        )}
                    </div>
                )}
            </div>
        )
    }

    const addRewardLinkedItemRow = () => {
        setRewardLinkedItems((prev) => [...prev, { item_id: '', variant_id: '' }])
    }

    const removeRewardLinkedItemRow = (index) => {
        setRewardLinkedItems((prev) => prev.filter((_, i) => i !== index))
    }

    const updateRewardLinkedItemRow = (index, patch) => {
        setRewardLinkedItems((prev) =>
            prev.map((row, i) => (i === index ? { ...row, ...patch } : row))
        )
    }

    const renderLinkedItemPicker = ({ itemId, variantId, onSelectItem, onSelectVariant, onClear, search, setSearch, page, setPage }) => {
        const selectedItem = menuItemsList.find((i) => i.item_id === itemId)
        const selectedVariant = selectedItem?.variants?.find((v) => v.variant_id === variantId)

        const filteredItems = !search
            ? menuItemsList
            : menuItemsList.filter((i) =>
                i.name.toLowerCase().includes(search.toLowerCase()) ||
                (i.category || '').toLowerCase().includes(search.toLowerCase())
            )

        return (
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Linked Menu Item <span className="text-xs text-gray-500">(optional — discount/eligibility applies only to this item)</span>
                </label>

                {selectedItem ? (
                    <div className="space-y-2">
                        <div className="flex items-center justify-between px-3 py-2 border border-[#8B5A3C] bg-[#F3EAE4] rounded-lg">
                            <div className="flex items-center gap-3">
                                <img
                                    src={selectedItem.item_img || '/placeholder.png'}
                                    alt={selectedItem.name}
                                    className="w-10 h-10 rounded object-cover flex-shrink-0"
                                />
                                <div>
                                    <p className="text-sm font-medium text-[#8B5A3C]">{selectedItem.name}</p>
                                    <p className="text-xs text-gray-500">
                                        Base price: ₱{Number(selectedItem.item_price).toFixed(2)} · {selectedItem.category}
                                    </p>
                                </div>
                            </div>
                            <button
                                type="button"
                                onClick={onClear}
                                className="text-sm font-medium text-red-600 hover:underline"
                            >
                                Remove
                            </button>
                        </div>

                        {selectedItem.variants?.length > 0 && (
                            <div>
                                <label className="block text-xs font-medium text-gray-600 mb-1">
                                    Specific Variant <span className="text-gray-400">(optional — leave blank to apply to base item)</span>
                                </label>
                                <select
                                    value={variantId || ''}
                                    onChange={(e) => onSelectVariant(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm"
                                >
                                    <option value="">Base item only</option>
                                    {selectedItem.variants.map((v) => (
                                        <option key={v.variant_id} value={v.variant_id}>
                                            {v.variant_name} (₱{Number(v.price).toFixed(2)})
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="space-y-2">
                        <input
                            type="text"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Search menu items by name..."
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                        />
                        <div className="max-h-48 overflow-y-auto border border-gray-200 rounded-lg divide-y divide-gray-100">
                            {filteredItems.length === 0 ? (
                                <div className="px-3 py-3 text-sm text-gray-500">No menu items found.</div>
                            ) : (
                                filteredItems
                                    .slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE)
                                    .map((item) => (
                                        <button
                                            key={item.item_id}
                                            type="button"
                                            onClick={() => { onSelectItem(item.item_id); setSearch('') }}
                                            className="w-full text-left px-3 py-2 hover:bg-gray-50 flex items-center gap-3"
                                        >
                                            <img
                                                src={item.item_img || '/placeholder.png'}
                                                alt={item.name}
                                                className="w-8 h-8 rounded object-cover flex-shrink-0"
                                            />
                                            <div>
                                                <p className="text-sm font-medium text-gray-800">{item.name}</p>
                                                <p className="text-xs text-gray-500">₱{Number(item.item_price).toFixed(2)} · {item.category}</p>
                                            </div>
                                        </button>
                                    ))
                            )}
                        </div>
                        {filteredItems.length > PAGE_SIZE && (
                            <Pagination
                                page={page}
                                totalItems={filteredItems.length}
                                pageSize={PAGE_SIZE}
                                onPageChange={setPage}
                            />
                        )}
                    </div>
                )}
            </div>
        )
    }

    const renderBranchSelector = () => (
        <div>
            <div className="flex items-center justify-between mb-2">
                <label className="text-sm font-medium text-gray-700">
                    Available Branches <span className="text-red-500">*</span>
                </label>
                <button
                    type="button"
                    onClick={handleToggleSelectAllBranches}
                    className="text-sm font-medium text-[#8B5A3C] hover:underline"
                >
                    {areAllBranchesSelected ? 'Clear All' : 'Select All'}
                </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                {branches.length === 0 ? (
                    <div className="text-sm text-gray-500 border border-gray-200 rounded-lg px-3 py-2">
                        No active branches available.
                    </div>
                ) : (
                    branches.map((branch) => {
                        const isChecked = selectedBranchIds.has(branch.branch_id)

                        return (
                            <label
                                key={branch.branch_id}
                                className={`flex items-center gap-3 px-3 py-2 rounded-lg border cursor-pointer transition-colors ${isChecked
                                        ? 'bg-[#F3EAE4] border-[#8B5A3C]'
                                        : 'bg-white border-gray-200 hover:bg-gray-50'
                                    }`}
                            >
                                <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={() => toggleBranchSelection(branch.branch_id)}
                                    className="w-4 h-4 accent-[#8B5A3C] cursor-pointer"
                                />
                                <span className={`text-sm font-medium ${isChecked ? 'text-[#8B5A3C]' : 'text-gray-700'}`}>
                                    {branch.name}
                                </span>
                            </label>
                        )
                    })
                )}
            </div>

            <p className="text-xs text-gray-500 mt-2">
                {selectedBranchIds.size} branch{selectedBranchIds.size !== 1 ? 'es' : ''} selected
            </p>
        </div>
    )

    return (
        <div className="flex-1 overflow-y-auto bg-gray-50">
            <Header
                title="Loyalty Management"
                subtitle="Manage rewards, challenges, and engagement campaigns"
                onGoToProfile={onGoToProfile}
            />

            <div className="px-8 pt-6">
                <div className="flex gap-2 flex-wrap">
                    {[
                        { key: 'overview', label: 'Overview' },
                        { key: 'tiers', label: 'Customer Tiers' },
                        { key: 'achievements', label: 'Achievements' },
                        { key: 'rewards', label: 'Rewards & Promotions' }
                    ].map((tab) => (
                        <button
                            key={tab.key}
                            onClick={() => setActiveTab(tab.key)}
                            className={`px-5 py-2.5 rounded-lg font-medium transition-colors ${activeTab === tab.key
                                    ? 'bg-[#8B5A3C] text-white'
                                    : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'
                                }`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>

            <div className="p-8">
                {/* <div className="grid grid-cols-3 gap-6 mb-8">
                    <div className="bg-white rounded-lg p-6 shadow-sm">
                        <div className="flex items-center gap-4">
                            <div className="w-14 h-14 bg-yellow-100 rounded-lg flex items-center justify-center flex-shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" className="text-yellow-600">
                                    <path fill="currentColor" d="M12 7a8 8 0 1 1 0 16a8 8 0 0 1 0-16m0 3.5l-1.322 2.68l-2.958.43l2.14 2.085l-.505 2.946L12 17.25l2.645 1.39l-.505-2.945l2.14-2.086l-2.958-.43zM18 2v3l-1.363 1.138A9.935 9.935 0 0 0 13 5.049L13.002 2zm-7-.001v3.05a9.935 9.935 0 0 0-3.636 1.088L6 5V2z"/>
                                </svg>
                            </div>
                            <div>
                                <p className="text-sm text-gray-600 mb-1">Active Members</p>
                                <h2 className="text-4xl font-bold text-gray-800">{activeMembersCount}</h2>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white rounded-lg p-6 shadow-sm">
                        <div className="flex items-center gap-4">
                            <div className="w-14 h-14 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"><g fill="none" fillRule="evenodd"><path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"/><path fill="#24bd00" d="M9 2a4 4 0 0 1 3 1.354A4 4 0 0 1 15 2h.5A1.5 1.5 0 0 1 17 3.5V4c0 .729-.195 1.412-.535 2H19a2 2 0 0 1 2 2v3a2 2 0 0 1-1 1.732V18a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-5.268A2 2 0 0 1 3 11V8a2 2 0 0 1 2-2h2.535A4 4 0 0 1 7 4v-.5A1.5 1.5 0 0 1 8.5 2zm9 11h-5v6h4l.117-.007a1 1 0 0 0 .876-.876L18 18zm-7 0H6v5a1 1 0 0 0 .883.993L7 19h4zm8-5h-6v3h6zm-8 0H5v3h6zM9 4a2 2 0 0 0 2 2a2 2 0 0 0-2-2m6 0a2 2 0 0 0-2 2a2 2 0 0 0 2-2"/></g></svg>
                            </div>
                            <div>
                                <p className="text-sm text-gray-600 mb-1">Rewards Redeemed Today</p>
                                <h2 className="text-4xl font-bold text-gray-800">{rewardsRedeemedTodayCount}</h2>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white rounded-lg p-6 shadow-sm">
                        <div className="flex items-center gap-4">
                            <div className="w-14 h-14 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" className="text-purple-600">
                                    <path fill="currentColor" d="M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2m-2 15l-5-5l1.41-1.41L10 14.17l7.59-7.59L19 8z"/>
                                </svg>
                            </div>
                            <div>
                                <p className="text-sm text-gray-600 mb-1">Challenge Completion Rate</p>
                                <h2 className="text-4xl font-bold text-gray-800">--</h2>
                            </div>
                        </div>
                    </div>
                </div> */}

                {/* Overview Tab */}
                {activeTab === 'overview' && (
                    <>

                        <LoyaltyAnalytics />
                        {/* <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-8">
                            <div className="bg-white rounded-lg p-6 shadow-sm">
                                <p className="text-sm text-gray-600 mb-1">Active Members</p>
                                <h2 className="text-4xl font-bold text-gray-800">{loyaltyStats.totalMembers}</h2>
                            </div>

                            <div className="bg-white rounded-lg p-6 shadow-sm">
                                <p className="text-sm text-gray-600 mb-1">Active Campaigns</p>
                                <h2 className="text-4xl font-bold text-gray-800">{loyaltyStats.totalCampaigns}</h2>
                            </div>

                            <div className="bg-white rounded-lg p-6 shadow-sm">
                                <p className="text-sm text-gray-600 mb-1">Reward Catalog</p>
                                <h2 className="text-4xl font-bold text-gray-800">{loyaltyStats.totalRewards}</h2>
                            </div>

                            <div className="bg-white rounded-lg p-6 shadow-sm">
                                <p className="text-sm text-gray-600 mb-1">Active Achievements</p>
                                <h2 className="text-4xl font-bold text-gray-800">{loyaltyStats.activeAchievements}</h2>
                            </div>
                        </div> */}

                        <div className="bg-white rounded-lg shadow-sm my-4">
                            <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
                                <h2 className="text-xl font-bold text-gray-800">Active Campaigns</h2>
                            </div>
                            <div className="divide-y divide-gray-200">
                                {activeCampaignsList.length === 0 ? (
                                    <div className="px-6 py-8 text-center text-gray-500">
                                        No active campaigns
                                    </div>
                                ) : (
                                    activeCampaignsList.map((campaign) => (
                                        <div key={campaign.id} className="px-6 py-4 hover:bg-gray-50 transition-colors">
                                            <div className="flex items-center justify-between">
                                                <div className="flex-1">
                                                    <div className="flex items-center gap-3 mb-2">
                                                        <span className="font-semibold text-gray-800">{campaign.name}</span>
                                                        <span className={`px-3 py-1 rounded-full text-xs font-medium ${getCampaignStatusColor(campaign.status)}`}>
                                                            {campaign.status.charAt(0).toUpperCase() + campaign.status.slice(1)}
                                                        </span>
                                                        <span className="px-3 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                                                            {campaign.type}
                                                        </span>
                                                    </div>
                                                    <p className="text-sm text-gray-600 mb-2">
                                                        <span className="font-medium">Reward:</span>{' '}
                                                        {campaign.linkedRewardId
                                                            ? rewardsCatalog.find(r => r.id === campaign.linkedRewardId)?.name || 'Linked reward'
                                                            : 'No linked reward'}
                                                    </p>
                                                    <div className="flex items-center gap-4 text-xs text-gray-500">
                                                        <span>
                                                            {new Date(campaign.startDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - {new Date(campaign.endDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="flex gap-2">
                                                    <button
                                                        onClick={() => openCampaignDetailsModal(campaign)}
                                                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                                                    >
                                                        View Details
                                                    </button>
                                                </div>                                        
                                                    </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    </>
                )}

                {/* Tiers Tab */}
                {activeTab === 'tiers' && (
                    <div className="bg-white rounded-lg shadow-sm">
                        <div className="px-6 py-4 border-b border-gray-200">
                            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                                <h2 className="text-xl font-bold text-gray-800 whitespace-nowrap">Customer Tier Management</h2>

                                <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto sm:ml-auto">
                                    <div className="relative flex-1 min-w-[180px] sm:flex-none">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                            </svg>
                                        </div>
                                        <input
                                            type="text"
                                            value={tierSearch}
                                            onChange={(e) => setTierSearch(e.target.value)}
                                            placeholder="Search tiers or benefits..."
                                            className="pl-9 pr-4 py-2 w-full sm:w-56 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#8B5A3C] focus:border-transparent"
                                        />
                                    </div>

                                    <button
                                        onClick={() => openArchivedViewerModal('tiers')}
                                        className="p-2 bg-gray-100 text-gray-700 hover:bg-gray-200 rounded-lg"
                                        title="View Archived Tiers"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                            <path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m3 6v10h12V9zm2 2h8v2H8zm0 4h8v2H8zM5 5v2h14V5z" />
                                        </svg>
                                    </button>

                                    <button
                                        onClick={openAddTierModal}
                                        className="bg-[#8B5A3C] hover:bg-[#6d4730] text-white font-medium px-4 py-2 rounded-lg transition-colors text-sm whitespace-nowrap"
                                    >
                                        + Add Tier
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="divide-y divide-gray-200">
                            {filteredTiers.length === 0 ? (
                                <div className="px-6 py-8 text-center text-gray-500">
                                    No tiers found matching "{tierSearch}"
                                </div>
                            ) : (
                                pagedTiers.map((tier) => (
                                    <div key={tier.id} className="px-6 py-5 hover:bg-gray-50 transition-colors">
                                        <div className="flex items-start justify-between">

                                            <div className="flex items-start gap-4">
                                                <img
                                                    src={tier.image_url || '/placeholder.png'}
                                                    alt={tier.name}
                                                    className="w-12 h-12 object-cover rounded-full"
                                                />

                                                <div className="flex flex-col">
                                                    <h3 className="text-lg font-semibold text-gray-800">
                                                        {tier.name}
                                                    </h3>
                                                    <p className="text-sm text-gray-600 mt-1">
                                                        {tier.maxPoints !== null
                                                            ? `${tier.minPoints} - ${tier.maxPoints} pts`
                                                            : `${tier.minPoints}+ pts`}
                                                    </p>

                                                    <div className="mt-2 space-y-1">
                                                        {tier.benefits.map((benefit, index) => (
                                                            <p key={index} className="text-sm text-gray-600">
                                                                • {benefit}
                                                            </p>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="flex items-center gap-1">
                                                <button onClick={() => openEditTierModal(tier)} className="p-1 text-blue-600 hover:bg-blue-50 rounded" title="Edit tier">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="m14.06 9l.94.94L5.92 19H5v-.92zm3.6-6c-.25 0-.51.1-.7.29l-1.83 1.83l3.75 3.75l1.83-1.83c.39-.39.39-1.04 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29m-3.6 3.19L3 17.25V21h3.75L17.81 9.94z" /></svg>
                                                </button>
                                                <button onClick={() => handleArchiveTier(tier.id, tier.name)} className="p-1 text-red-600 hover:bg-red-50 rounded" title="Archive tier">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                        <path fill="currentColor" d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2z" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )))}
                        </div>
                        <Pagination
                            page={tierPage}
                            totalItems={filteredTiers.length}
                            pageSize={TIER_PAGE_SIZE}
                            onPageChange={setTierPage}
                        />
                    </div>
                )}

                {/* Achievements Tab */}
                {activeTab === 'achievements' && (
                    <div className="bg-white rounded-lg shadow-sm">
                        <div className="px-6 py-4 border-b border-gray-200">
                            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                                <h2 className="text-xl font-bold text-gray-800 whitespace-nowrap">Customer Achievement Management</h2>

                                <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto sm:ml-auto">
                                    <div className="relative flex-1 min-w-[180px] sm:flex-none">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                            </svg>
                                        </div>
                                        <input
                                            type="text"
                                            value={achievementSearch}
                                            onChange={(e) => setAchievementSearch(e.target.value)}
                                            placeholder="Search achievements..."
                                            className="pl-9 pr-4 py-2 w-full sm:w-56 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#8B5A3C] focus:border-transparent"
                                        />
                                    </div>

                                    <button
                                        onClick={() => openArchivedViewerModal('achievements')}
                                        className="p-2 bg-gray-100 text-gray-700 hover:bg-gray-200 rounded-lg"
                                        title="View Archived Achievements"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                            <path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m3 6v10h12V9zm2 2h8v2H8zm0 4h8v2H8zM5 5v2h14V5z" />
                                        </svg>
                                    </button>

                                    <button
                                        onClick={openAddAchievementModal}
                                        className="bg-[#8B5A3C] hover:bg-[#6d4730] text-white font-medium px-4 py-2 rounded-lg transition-colors text-sm whitespace-nowrap"
                                    >
                                        + Create Achievement
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="divide-y divide-gray-200">
                            {filteredAchievements.length === 0 ? (
                                <div className="px-6 py-8 text-center text-gray-500">
                                    No achievements found matching "{achievementSearch}"
                                </div>
                            ) : (
                                pagedAchievements.map((achievement) => (
                                    <div key={achievement.id} className="px-6 py-5 hover:bg-gray-50 transition-colors">
                                        <div className="flex items-center justify-between">

                                            <div className="flex items-start gap-4">
                                                <img
                                                    src={achievement.image_url || '/placeholder.png'}
                                                    alt={achievement.name}
                                                    className="w-12 h-12 object-cover rounded-full"
                                                />
                                                <div className="flex flex-col">
                                                    <h3 className="text-lg font-semibold text-gray-800">
                                                        {achievement.title}
                                                    </h3>
                                                    <p className="text-sm text-gray-500 mt-2">
                                                        {achievement.description}
                                                    </p>
                                                    <p className="text-xs text-gray-500 mt-2">
                                                        Condition: {achievement.condition}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="text-right">
                                                <p className="text-sm text-gray-500">Reward</p>
                                                <p className="text-lg font-bold text-gray-800">
                                                    {achievement.rewardPoints} pts
                                                </p>
                                                <span className={`inline-block mt-2 px-3 py-1 rounded-full text-xs font-medium ${getAchievementStatusColor(achievement.status)}`}>
                                                    {achievement.status}
                                                </span>

                                                <div className="mt-3 flex justify-end gap-2">
                                                    {achievementView !== 'archived' && (
                                                        <button
                                                            onClick={() => openEditAchievementModal(achievement)}
                                                            className="p-1 text-blue-600 hover:bg-blue-50 rounded"
                                                            title="Edit item"
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                                <path fill="currentColor" d="m14.06 9l.94.94L5.92 19H5v-.92zm3.6-6c-.25 0-.51.1-.7.29l-1.83 1.83l3.75 3.75l1.83-1.83c.39-.39.39-1.04 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29m-3.6 3.19L3 17.25V21h3.75L17.81 9.94z" />
                                                            </svg>
                                                        </button>
                                                    )}

                                                    {achievementView === 'archived' ? (
                                                        <button
                                                            onClick={() => handleReinstateAchievement(achievement.id)}
                                                            className="px-4 py-2 text-sm font-medium text-green-700 bg-green-100 hover:bg-green-200 rounded-lg"
                                                        >
                                                            Reinstate
                                                        </button>
                                                    ) : (
                                                        <button
                                                            onClick={() => handleArchiveAchievement(achievement.id, achievement.title)}
                                                            className="p-2 text-red-600 hover:bg-red-50 rounded-lg"
                                                            title="Archive achievement"
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                                <path fill="currentColor" d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2z" />
                                                            </svg>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                        <Pagination
                            page={achievementPage}
                            totalItems={filteredAchievements.length}
                            pageSize={PAGE_SIZE}
                            onPageChange={setAchievementPage}
                        />
                    </div>
                )}

                {/* Rewards Tab */}
                {activeTab === 'rewards' && (
                    <div className="space-y-8">
                        <div className="bg-white rounded-lg shadow-sm">
                            <div className="px-6 py-4 border-b border-gray-200">
                                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                                    <h2 className="text-xl font-bold text-gray-800 whitespace-nowrap">Reward Management</h2>

                                    <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto sm:ml-auto">
                                        <div className="relative flex-1 min-w-[160px] sm:flex-none">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                                </svg>
                                            </div>
                                            <input
                                                type="text"
                                                value={rewardSearch}
                                                onChange={(e) => setRewardSearch(e.target.value)}
                                                placeholder="Search rewards..."
                                                className="pl-9 pr-4 py-2 w-full sm:w-52 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#8B5A3C] focus:border-transparent"
                                            />
                                        </div>

                                        <select
                                            value={rewardAvailabilityFilter}
                                            onChange={(e) => setRewardAvailabilityFilter(e.target.value)}
                                            className="px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#8B5A3C] bg-white"
                                        >
                                            <option value="all">All Availability</option>
                                            <option value="permanent">Permanent</option>
                                            <option value="limited">Limited-Time</option>
                                        </select>

                                        <select
                                            value={rewardView}
                                            onChange={(e) => setRewardView(e.target.value)}
                                            className="px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#8B5A3C] bg-white"
                                        >
                                            <option value="active">Active</option>
                                            <option value="completed">Completed</option>
                                        </select>

                                        <button
                                            onClick={() => openArchivedViewerModal('rewards')}
                                            className="p-2 bg-gray-100 text-gray-700 hover:bg-gray-200 rounded-lg"
                                            title="View Archived Rewards"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                <path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m3 6v10h12V9zm2 2h8v2H8zm0 4h8v2H8zM5 5v2h14V5z" />
                                            </svg>
                                        </button>

                                        <button
                                            onClick={openAddRewardModal}
                                            className="bg-[#8B5A3C] hover:bg-[#6d4730] text-white font-medium px-4 py-2 rounded-lg transition-colors text-sm whitespace-nowrap"
                                        >
                                            + Add Reward
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="divide-y divide-gray-200">
                                {visibleRewards.length === 0 ? (
                                    <div className="px-6 py-8 text-center text-gray-500">
                                        No rewards found
                                    </div>
                                ) : (
                                    pagedRewards.map((reward) => (
                                        <div key={reward.id} className="px-6 py-4 hover:bg-gray-50 transition-colors">
                                            <div className="flex items-center justify-between">
                                                <div>
                                                    <p className="font-semibold text-gray-800">{reward.name}</p>
                                                    <p className="text-sm text-gray-500 mt-1">{reward.type}</p>
                                                    <p className="text-xs text-gray-500 mt-1 line-clamp-2">
                                                        Mechanics: {reward.mechanics}
                                                    </p>
                                                </div>

                                                <div className="text-right">
                                                    <p className="font-bold text-gray-800">{reward.pointsRequired} pts</p>
                                                    <p className="text-xs text-gray-500 mt-1">{reward.rewardDurationType}</p>
                                                    {reward.rewardDurationType === 'Limited' && reward.startDate && reward.endDate && (
                                                        <p className="text-xs text-gray-500 mt-1">
                                                            {reward.startDate} to {reward.endDate}
                                                        </p>
                                                    )}
                                                    <div className="mt-3 flex justify-end gap-2">
                                                        {rewardView !== 'archived' && (
                                                            <button onClick={() => openEditRewardModal(reward)} className="p-1 text-blue-600 hover:bg-blue-50 rounded" title="Edit item">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="m14.06 9l.94.94L5.92 19H5v-.92zm3.6-6c-.25 0-.51.1-.7.29l-1.83 1.83l3.75 3.75l1.83-1.83c.39-.39.39-1.04 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29m-3.6 3.19L3 17.25V21h3.75L17.81 9.94z" /></svg>
                                                            </button>
                                                        )}

                                                        {rewardView === 'archived' ? (
                                                            <button
                                                                onClick={() => handleReinstateReward(reward.id)}
                                                                className="px-4 py-2 text-sm font-medium text-green-700 bg-green-100 hover:bg-green-200 rounded-lg transition-colors"
                                                            >
                                                                Reinstate
                                                            </button>
                                                        ) : (
                                                            <button
                                                                onClick={() => handleArchiveReward(reward.id, reward.name)}
                                                                className="p-2 text-red-600 hover:bg-red-50 rounded-lg"
                                                                title="Archive reward"
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                                    <path
                                                                        fill="currentColor"
                                                                        d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2z"
                                                                    />
                                                                </svg>
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                            <Pagination
                                page={rewardPage}
                                totalItems={filteredRewards.length}
                                pageSize={PAGE_SIZE}
                                onPageChange={setRewardPage}
                            />
                        </div>

                        <div className="bg-white rounded-lg shadow-sm">
                            <div className="px-6 py-4 border-b border-gray-200">
                                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                                    <h2 className="text-xl font-bold text-gray-800 whitespace-nowrap">Promotion & Campaign Management</h2>

                                    <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto sm:ml-auto">
                                        <div className="relative flex-1 min-w-[160px] sm:flex-none">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <svg className="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                                </svg>
                                            </div>
                                            <input
                                                type="text"
                                                value={campaignSearch}
                                                onChange={(e) => setCampaignSearch(e.target.value)}
                                                placeholder="Search campaigns..."
                                                className="pl-9 pr-4 py-2 w-full sm:w-52 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#8B5A3C] focus:border-transparent"
                                            />
                                        </div>

                                        <select
                                            value={campaignView}
                                            onChange={(e) => setCampaignView(e.target.value)}
                                            className="px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#8B5A3C] bg-white"
                                        >
                                            <option value="active">Active</option>
                                            <option value="completed">Completed</option>
                                        </select>

                                        <button
                                            onClick={() => openArchivedViewerModal('campaigns')}
                                            className="p-2 bg-gray-100 text-gray-700 hover:bg-gray-200 rounded-lg"
                                            title="View Archived Campaigns"
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                <path fill="currentColor" d="M3 3h18a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m3 6v10h12V9zm2 2h8v2H8zm0 4h8v2H8zM5 5v2h14V5z" />
                                            </svg>
                                        </button>

                                        <button
                                            onClick={openAddCampaignModal}
                                            className="bg-[#8B5A3C] hover:bg-[#6d4730] text-white font-medium px-4 py-2 rounded-lg transition-colors text-sm whitespace-nowrap"
                                        >
                                            + Create Campaign
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="divide-y divide-gray-200">
                                {filteredCampaigns.length === 0 ? (
                                    <div className="px-6 py-8 text-center text-gray-500">
                                        {campaignSearch ? `No campaigns found matching "${campaignSearch}"` : 'No campaigns found'}
                                    </div>
                                ) : (
                                    pagedCampaigns.map((campaign) => (
                                        <div key={campaign.id} className="px-6 py-4 hover:bg-gray-50 transition-colors">
                                            <div className="flex items-center justify-between">
                                                <div>
                                                    <div className="flex items-center gap-3 mb-2">
                                                        <span className="font-semibold text-gray-800">{campaign.name}</span>
                                                        <span className={`px-3 py-1 rounded-full text-xs font-medium ${getCampaignStatusColor(campaign.status)}`}>
                                                            {campaign.status.charAt(0).toUpperCase() + campaign.status.slice(1)}
                                                        </span>
                                                        <span className="px-3 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                                                            {campaign.type}
                                                        </span>
                                                    </div>
                                                    <p className="text-sm text-gray-600">
                                                        {campaign.linkedRewardId
                                                            ? rewardsCatalog.find(r => r.id === campaign.linkedRewardId)?.name || 'Linked reward'
                                                            : 'No linked reward'}
                                                    </p>
                                                    <p className="text-xs text-gray-500 mt-1 line-clamp-2">
                                                        Mechanics: {campaign.mechanics}
                                                    </p>
                                                </div>

                                                <div className="mt-3 flex justify-end gap-2">
                                                    {campaignView !== 'archived' && (
                                                        <button onClick={() => openEditCampaignModal(campaign)} className="p-1 text-blue-600 hover:bg-blue-50 rounded" title="Edit item">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="m14.06 9l.94.94L5.92 19H5v-.92zm3.6-6c-.25 0-.51.1-.7.29l-1.83 1.83l3.75 3.75l1.83-1.83c.39-.39.39-1.04 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29m-3.6 3.19L3 17.25V21h3.75L17.81 9.94z" /></svg>
                                                        </button>
                                                    )}

                                                    {campaignView === 'archived' ? (
                                                        <button
                                                            onClick={() => handleReinstateCampaign(campaign.id)}
                                                            className="px-4 py-2 text-sm font-medium text-green-700 bg-green-100 hover:bg-green-200 rounded-lg transition-colors"
                                                        >
                                                            Reinstate
                                                        </button>
                                                    ) : (
                                                        <button
                                                            onClick={() => handleArchiveCampaign(campaign.id, campaign.name)}
                                                            className="p-2 text-red-600 hover:bg-red-50 rounded-lg"
                                                            title="Archive campaign"
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                                <path
                                                                    fill="currentColor"
                                                                    d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2z"
                                                                />
                                                            </svg>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                            <Pagination
                                page={campaignPage}
                                totalItems={filteredCampaigns.length}
                                pageSize={PAGE_SIZE}
                                onPageChange={setCampaignPage}
                            />
                        </div>
                    </div>
                )}
            </div>

            {/* Add Tier Modal */}
            {showAddTierModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => { setShowAddTierModal(false); resetTierForm() }}></div>
                    <div className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4 flex-shrink-0">
                            <h2 className="text-xl font-bold text-gray-800">Add Tier</h2>
                            <p className="text-sm text-gray-500 mt-1">Create a new customer tier with a points range and its member benefits.</p>
                        </div>

                        <div className="px-6 py-6 space-y-4 overflow-y-auto flex-1">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Tier Name <span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        value={tierFormData.name}
                                        onChange={(e) => setTierFormData({ ...tierFormData, name: e.target.value })}
                                        maxLength={MAX_LENGTHS.tierName}
                                        placeholder="Enter tier name"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                    <p className="text-xs text-gray-500 mt-1">{tierFormData.name.length}/{MAX_LENGTHS.tierName} characters</p>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Minimum Points <span className="text-red-500">*</span></label>
                                    <input
                                        type="number"
                                        min="0"
                                        value={tierFormData.minPoints}
                                        onChange={(e) => {
                                            if (e.target.value.length <= MAX_LENGTHS.minPoints) {
                                                setTierFormData({ ...tierFormData, minPoints: e.target.value })
                                            }
                                        }}
                                        onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                                        placeholder="0"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                    <p className="text-xs text-gray-500 mt-1">
                                        {String(tierFormData.minPoints).length}/{MAX_LENGTHS.minPoints} digits
                                    </p>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Maximum Points</label>
                                    <input
                                        type="number"
                                        min="0"
                                        value={tierFormData.maxPoints}
                                        onChange={(e) => {
                                            if (e.target.value.length <= MAX_LENGTHS.maxPoints) {
                                                setTierFormData({ ...tierFormData, maxPoints: e.target.value })
                                            }
                                        }}
                                        onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                                        placeholder="Leave blank if open-ended"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                    <p className="text-xs text-gray-500 mt-1">
                                        {String(tierFormData.maxPoints || '').length}/{MAX_LENGTHS.maxPoints} digits
                                    </p>
                                </div>
                            </div>

                            <div>
                                <div className="flex items-center justify-between mb-2">
                                    <label className="text-sm font-medium text-gray-700">Benefits <span className="text-red-500">*</span></label>
                                    <button
                                        type="button"
                                        onClick={addBenefitField}
                                        className="text-sm font-medium text-[#8B5A3C] hover:underline"
                                    >
                                        + Add Benefit
                                    </button>
                                </div>

                                <div className="space-y-3">
                                    {tierFormData.benefits.map((benefit, index) => (
                                        <div key={index} className="flex items-start gap-2">
                                            <div className="flex-1">
                                                <input
                                                    type="text"
                                                    value={benefit}
                                                    onChange={(e) => handleBenefitChange(index, e.target.value)}
                                                    maxLength={MAX_LENGTHS.benefit}
                                                    placeholder={`Benefit ${index + 1}`}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                                />
                                                <p className="text-xs text-gray-500 mt-1">{benefit.length}/{MAX_LENGTHS.benefit} characters</p>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={() => removeBenefitField(index)}
                                                className="mt-0 px-3 py-2 text-sm font-medium text-red-600 hover:bg-red-50 rounded-lg"
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Tier Badge Image</label>

                                <div className="inline-flex mb-3 rounded-lg bg-gray-100 p-1">
                                    <button
                                        type="button"
                                        onClick={() => setTierImageInputMode('upload')}
                                        className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${tierImageInputMode === 'upload'
                                                ? 'bg-[#8B5A3C] text-white shadow-sm'
                                                : 'bg-transparent text-gray-600 hover:text-gray-800'
                                            }`}
                                    >
                                        Upload Image
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => setTierImageInputMode('url')}
                                        className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${tierImageInputMode === 'url'
                                                ? 'bg-[#8B5A3C] text-white shadow-sm'
                                                : 'bg-transparent text-gray-600 hover:text-gray-800'
                                            }`}
                                    >
                                        Use Image URL
                                    </button>
                                </div>

                                {tierImageInputMode === 'upload' ? (
                                    <div className="space-y-2">
                                        <input
                                            type="file"
                                            accept="image/png,image/jpeg,image/webp"
                                            onChange={(e) => setTierImageFile(e.target.files?.[0] || null)}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                        />
                                        <p className="text-xs text-gray-500">Accepted: JPG, PNG, WEBP. Max size: 5MB.</p>
                                    </div>
                                ) : (
                                    <input
                                        type="text"
                                        value={tierFormData.image_url}
                                        onChange={(e) => setTierFormData({ ...tierFormData, image_url: e.target.value })}
                                        placeholder="https://example.com/tier-badge.png"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                )}

                                {(tierFormData.image_url || tierImageFile) && (
                                    <p className="text-xs text-gray-500 mt-2">
                                        {tierImageFile ? `Selected file: ${tierImageFile.name}` : 'Image URL provided'}
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3 flex-shrink-0">
                            <button
                                onClick={() => { setShowAddTierModal(false); resetTierForm() }}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleAddTier}
                                disabled={!hasAddTierChanges}
                                className={`px-6 py-2 rounded-lg font-medium ${!hasAddTierChanges
                                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                        : 'bg-[#8B5A3C] text-white hover:bg-[#6d4730]'
                                    }`}
                            >
                                Save Tier
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Tier Modal */}
            {showEditTierModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => { setShowEditTierModal(false); setEditingTier(null); resetTierForm() }}></div>
                    <div className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4 flex-shrink-0">
                            <h2 className="text-xl font-bold text-gray-800">Edit Tier</h2>
                            <p className="text-sm text-gray-500 mt-1">Update this tier's name, points range, benefits, or badge image.</p>
                        </div>

                        <div className="px-6 py-6 space-y-4 overflow-y-auto flex-1">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Tier Name <span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        value={tierFormData.name}
                                        onChange={(e) => setTierFormData({ ...tierFormData, name: e.target.value })}
                                        maxLength={MAX_LENGTHS.tierName}
                                        placeholder="Enter tier name"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                    <p className="text-xs text-gray-500 mt-1">{tierFormData.name.length}/{MAX_LENGTHS.tierName} characters</p>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Minimum Points <span className="text-red-500">*</span></label>
                                    <input
                                        type="number"
                                        min="0"
                                        value={tierFormData.minPoints}
                                        onChange={(e) => {
                                            if (e.target.value.length <= MAX_LENGTHS.minPoints) {
                                                setTierFormData({ ...tierFormData, minPoints: e.target.value })
                                            }
                                        }}
                                        onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                                        placeholder="0"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                    <p className="text-xs text-gray-500 mt-1">
                                        {String(tierFormData.minPoints).length}/{MAX_LENGTHS.minPoints} digits
                                    </p>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Maximum Points</label>
                                    <input
                                        type="number"
                                        min="0"
                                        value={tierFormData.maxPoints}
                                        onChange={(e) => {
                                            if (e.target.value.length <= MAX_LENGTHS.maxPoints) {
                                                setTierFormData({ ...tierFormData, maxPoints: e.target.value })
                                            }
                                        }}
                                        onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                                        placeholder="Leave blank if open-ended"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                    <p className="text-xs text-gray-500 mt-1">
                                        {String(tierFormData.maxPoints || '').length}/{MAX_LENGTHS.maxPoints} digits
                                    </p>
                                </div>
                            </div>

                            <div>
                                <div className="flex items-center justify-between mb-2">
                                    <label className="text-sm font-medium text-gray-700">Benefits <span className="text-red-500">*</span></label>
                                    <button
                                        type="button"
                                        onClick={addBenefitField}
                                        className="text-sm font-medium text-[#8B5A3C] hover:underline"
                                    >
                                        + Add Benefit
                                    </button>
                                </div>

                                <div className="space-y-3">
                                    {tierFormData.benefits.map((benefit, index) => (
                                        <div key={index} className="flex items-start gap-2">
                                            <div className="flex-1">
                                                <input
                                                    type="text"
                                                    value={benefit}
                                                    onChange={(e) => handleBenefitChange(index, e.target.value)}
                                                    maxLength={MAX_LENGTHS.benefit}
                                                    placeholder={`Benefit ${index + 1}`}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                                />
                                                <p className="text-xs text-gray-500 mt-1">{benefit.length}/{MAX_LENGTHS.benefit} characters</p>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={() => removeBenefitField(index)}
                                                className="mt-0 px-3 py-2 text-sm font-medium text-red-600 hover:bg-red-50 rounded-lg"
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Tier Badge Image</label>

                                <div className="inline-flex mb-3 rounded-lg bg-gray-100 p-1">
                                    <button
                                        type="button"
                                        onClick={() => setTierImageInputMode('upload')}
                                        className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${tierImageInputMode === 'upload'
                                                ? 'bg-[#8B5A3C] text-white shadow-sm'
                                                : 'bg-transparent text-gray-600 hover:text-gray-800'
                                            }`}
                                    >
                                        Upload Image
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => setTierImageInputMode('url')}
                                        className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${tierImageInputMode === 'url'
                                                ? 'bg-[#8B5A3C] text-white shadow-sm'
                                                : 'bg-transparent text-gray-600 hover:text-gray-800'
                                            }`}
                                    >
                                        Use Image URL
                                    </button>
                                </div>

                                {tierImageInputMode === 'upload' ? (
                                    <div className="space-y-2">
                                        <input
                                            type="file"
                                            accept="image/png,image/jpeg,image/webp"
                                            onChange={(e) => setTierImageFile(e.target.files?.[0] || null)}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                        />
                                        <p className="text-xs text-gray-500">Accepted: JPG, PNG, WEBP. Max size: 5MB.</p>
                                    </div>
                                ) : (
                                    <input
                                        type="text"
                                        value={tierFormData.image_url}
                                        onChange={(e) => setTierFormData({ ...tierFormData, image_url: e.target.value })}
                                        placeholder="https://example.com/tier-badge.png"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                )}

                                {(tierFormData.image_url || tierImageFile) && (
                                    <p className="text-xs text-gray-500 mt-2">
                                        {tierImageFile ? `Selected file: ${tierImageFile.name}` : 'Image URL provided'}
                                    </p>
                                )}
                            </div>

                        </div>


                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3 flex-shrink-0">
                            <button
                                onClick={() => { setShowEditTierModal(false); setEditingTier(null); resetTierForm() }}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleUpdateTier}
                                disabled={!hasEditTierChanges}
                                className={`px-6 py-2 rounded-lg font-medium ${!hasEditTierChanges
                                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                        : 'bg-[#8B5A3C] text-white hover:bg-[#6d4730]'
                                    }`}
                            >
                                Save Changes
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Add Achievement Modal */}
            {showAddAchievementModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => { setShowAddAchievementModal(false); resetAchievementForm() }}></div>
                    <div className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4 flex-shrink-0">
                            <h2 className="text-xl font-bold text-gray-800">Create Achievement</h2>
                            <p className="text-sm text-gray-500 mt-1">Define a goal customers can unlock, along with its reward points and condition.</p>
                        </div>

                        <div className="px-6 py-6 space-y-4 overflow-y-auto flex-1">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Title <span className="text-red-500">*</span></label>
                                <input
                                    type="text"
                                    value={achievementFormData.title}
                                    onChange={(e) => setAchievementFormData({ ...achievementFormData, title: e.target.value })}
                                    maxLength={MAX_LENGTHS.achievementTitle}
                                    placeholder="Enter achievement title"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                />
                                <p className="text-xs text-gray-500 mt-1">{achievementFormData.title.length}/{MAX_LENGTHS.achievementTitle} characters</p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Description <span className="text-red-500">*</span></label>
                                <textarea
                                    value={achievementFormData.description}
                                    onChange={(e) => setAchievementFormData({ ...achievementFormData, description: e.target.value })}
                                    rows="4"
                                    maxLength={MAX_LENGTHS.achievementDescription}
                                    placeholder="Describe the achievement"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                ></textarea>
                                <p className="text-xs text-gray-500 mt-1">{achievementFormData.description.length}/{MAX_LENGTHS.achievementDescription} characters</p>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Reward Points <span className="text-red-500">*</span></label>
                                    <input
                                        type="number"
                                        min="0"
                                        maxLength={6}
                                        value={achievementFormData.rewardPoints}
                                        onChange={(e) => {
                                            if (e.target.value.length <= MAX_LENGTHS.rewardPoints) {
                                                setAchievementFormData({ ...achievementFormData, rewardPoints: e.target.value })
                                            }
                                        }}
                                        onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                                        placeholder="0"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                    <p className="text-xs text-gray-500 mt-1">
                                        {String(achievementFormData.rewardPoints).length}/{MAX_LENGTHS.rewardPoints} digits
                                    </p>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Status <span className="text-red-500">*</span></label>
                                    <select
                                        value={achievementFormData.status}
                                        onChange={(e) => setAchievementFormData({ ...achievementFormData, status: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    >
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                </div>
                            </div>

                            {/* Rule Type */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Achievement Rule Type <span className="text-red-500">*</span>
                                </label>
                                <select
                                    value={achievementFormData.rule_type}
                                    onChange={(e) => setAchievementFormData({
                                        ...achievementFormData,
                                        rule_type: e.target.value,
                                        category_name: '',
                                        branch_id: '',
                                        target_value: '',
                                        timeframe_type: 'none'
                                    })}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                >
                                    <option value="completed_orders">Completed Orders</option>
                                    <option value="category_orders">Category Orders</option>
                                    <option value="total_spend">Total Spend (₱)</option>
                                    <option value="branch_visits">Branch Visits</option>
                                    <option value="reward_redemptions">Reward Redemptions</option>
                                </select>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {/* Target Value */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        {achievementFormData.rule_type === 'total_spend' ? 'Target Amount (₱)' : 'Target Count'} <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min="1"
                                        value={achievementFormData.target_value}
                                        onChange={(e) => {
                                            if (e.target.value.length <= MAX_LENGTHS.targetValue) {
                                                setAchievementFormData({ ...achievementFormData, target_value: e.target.value })
                                            }
                                        }}
                                        onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                                        placeholder={achievementFormData.rule_type === 'total_spend' ? 'e.g. 1000' : 'e.g. 5'}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                    <p className="text-xs text-gray-500 mt-1">
                                        {String(achievementFormData.target_value || '').length}/{MAX_LENGTHS.targetValue} digits
                                    </p>
                                </div>

                                {/* Timeframe */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Timeframe</label>
                                    <select
                                        value={achievementFormData.timeframe_type}
                                        onChange={(e) => setAchievementFormData({ ...achievementFormData, timeframe_type: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    >
                                        <option value="none">Permanent</option>
                                        <option value="daily">Daily</option>
                                        <option value="weekly">Weekly</option>
                                        <option value="monthly">Monthly</option>
                                    </select>
                                </div>
                            </div>

                            {/* Category Name — only for category_orders */}
                            {achievementFormData.rule_type === 'category_orders' && (
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Item Category <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        value={achievementFormData.category_name}
                                        onChange={(e) => setAchievementFormData({ ...achievementFormData, category_name: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    >
                                        <option value="">Select category</option>
                                        {menuCategories.map((cat) => (
                                            <option key={cat} value={cat}>{cat}</option>
                                        ))}
                                    </select>
                                    {menuCategories.length === 0 && (
                                        <p className="text-xs text-gray-500 mt-1">No categories found in menu.</p>
                                    )}
                                </div>
                            )}
                            {/* Branch — only for branch_visits */}
                            {achievementFormData.rule_type === 'branch_visits' && (
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Specific Branch <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        value={achievementFormData.branch_id}
                                        onChange={(e) => setAchievementFormData({ ...achievementFormData, branch_id: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    >
                                        <option value="">Any branch</option>
                                        {branches.map((branch) => (
                                            <option key={branch.branch_id} value={branch.branch_id}>{branch.name}</option>
                                        ))}
                                    </select>
                                </div>
                            )}

                            {/* Auto-generated condition label preview */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Condition Label</label>
                                <input
                                    type="text"
                                    value={achievementFormData.condition_label}
                                    onChange={(e) => setAchievementFormData({ ...achievementFormData, condition_label: e.target.value })}
                                    placeholder="Auto-filled or write a custom label"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C] bg-gray-50"
                                />
                                <p className="text-xs text-gray-500 mt-1">{achievementFormData.condition_label.length}/{MAX_LENGTHS.achievementCondition} characters</p>
                                <p className="text-xs text-gray-500">Shown to customers. Leave blank to auto-generate.</p>                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Badge Image</label>

                                <div className="inline-flex mb-3 rounded-lg bg-gray-100 p-1">
                                    <button
                                        type="button"
                                        onClick={() => setAchievementImageInputMode('upload')}
                                        className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${achievementImageInputMode === 'upload'
                                                ? 'bg-[#8B5A3C] text-white shadow-sm'
                                                : 'bg-transparent text-gray-600 hover:text-gray-800'
                                            }`}
                                    >
                                        Upload Image
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => setAchievementImageInputMode('url')}
                                        className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${achievementImageInputMode === 'url'
                                                ? 'bg-[#8B5A3C] text-white shadow-sm'
                                                : 'bg-transparent text-gray-600 hover:text-gray-800'
                                            }`}
                                    >
                                        Use Image URL
                                    </button>
                                </div>

                                {achievementImageInputMode === 'upload' ? (
                                    <div className="space-y-2">
                                        <input
                                            type="file"
                                            accept="image/png,image/jpeg,image/webp"
                                            onChange={(e) => setAchievementImageFile(e.target.files?.[0] || null)}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                        />
                                        <p className="text-xs text-gray-500">Accepted: JPG, PNG, WEBP. Max size: 5MB.</p>
                                    </div>
                                ) : (
                                    <input
                                        type="text"
                                        value={achievementFormData.image_url}
                                        onChange={(e) => setAchievementFormData({ ...achievementFormData, image_url: e.target.value })}
                                        placeholder="https://example.com/badge.png"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                )}

                                {(achievementFormData.image_url || achievementImageFile) && (
                                    <p className="text-xs text-gray-500 mt-2">
                                        {achievementImageFile ? `Selected file: ${achievementImageFile.name}` : 'Image URL provided'}
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3 flex-shrink-0">
                            <button
                                onClick={() => { setShowAddAchievementModal(false); resetAchievementForm() }}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleAddAchievement}
                                disabled={!hasAddAchievementChanges}
                                className={`px-6 py-2 rounded-lg font-medium ${!hasAddAchievementChanges
                                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                        : 'bg-[#8B5A3C] text-white hover:bg-[#6d4730]'
                                    }`}
                            >
                                Save Achievement
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Achivement Modal */}
            {showEditAchievementModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => { setShowEditAchievementModal(false); setEditingAchievement(null); resetAchievementForm() }}></div>
                    <div className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4 flex-shrink-0">
                            <h2 className="text-xl font-bold text-gray-800">Edit Achievement</h2>
                            <p className="text-sm text-gray-500 mt-1">Update this achievement's rule, target, reward points, or badge.</p>
                        </div>

                        <div className="px-6 py-6 space-y-4 overflow-y-auto flex-1">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Title <span className="text-red-500">*</span></label>
                                <input
                                    type="text"
                                    value={achievementFormData.title}
                                    onChange={(e) => setAchievementFormData({ ...achievementFormData, title: e.target.value })}
                                    maxLength={MAX_LENGTHS.achievementTitle}
                                    placeholder="Enter achievement title"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                />
                                <p className="text-xs text-gray-500 mt-1">{achievementFormData.title.length}/{MAX_LENGTHS.achievementTitle} characters</p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Description <span className="text-red-500">*</span></label>
                                <textarea
                                    value={achievementFormData.description}
                                    onChange={(e) => setAchievementFormData({ ...achievementFormData, description: e.target.value })}
                                    rows="4"
                                    maxLength={MAX_LENGTHS.achievementDescription}
                                    placeholder="Describe the achievement"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                ></textarea>
                                <p className="text-xs text-gray-500 mt-1">{achievementFormData.description.length}/{MAX_LENGTHS.achievementDescription} characters</p>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Reward Points <span className="text-red-500">*</span></label>
                                    <input
                                        type="number"
                                        min="0"
                                        value={achievementFormData.rewardPoints}
                                        onChange={(e) => {
                                            if (e.target.value.length <= MAX_LENGTHS.rewardPoints) {
                                                setAchievementFormData({ ...achievementFormData, rewardPoints: e.target.value })
                                            }
                                        }}
                                        onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                                        placeholder="0"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                    <p className="text-xs text-gray-500 mt-1">
                                        {String(achievementFormData.rewardPoints).length}/{MAX_LENGTHS.rewardPoints} digits
                                    </p>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Status <span className="text-red-500">*</span></label>
                                    <select
                                        value={achievementFormData.status}
                                        onChange={(e) => setAchievementFormData({ ...achievementFormData, status: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    >
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                </div>
                            </div>

                            {/* Rule Type */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Achievement Rule Type <span className="text-red-500">*</span>
                                </label>
                                <select
                                    value={achievementFormData.rule_type}
                                    onChange={(e) => setAchievementFormData({
                                        ...achievementFormData,
                                        rule_type: e.target.value,
                                        category_name: '',
                                        branch_id: '',
                                        target_value: '',
                                        timeframe_type: 'none'
                                    })}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                >
                                    <option value="completed_orders">Completed Orders</option>
                                    <option value="category_orders">Category Orders</option>
                                    <option value="total_spend">Total Spend (₱)</option>
                                    <option value="branch_visits">Branch Visits</option>
                                    <option value="reward_redemptions">Reward Redemptions</option>
                                </select>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {/* Target Value */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        {achievementFormData.rule_type === 'total_spend' ? 'Target Amount (₱)' : 'Target Count'} <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min="1"
                                        value={achievementFormData.target_value}
                                        onChange={(e) => {
                                            if (e.target.value.length <= MAX_LENGTHS.targetValue) {
                                                setAchievementFormData({ ...achievementFormData, target_value: e.target.value })
                                            }
                                        }}
                                        onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                                        placeholder={achievementFormData.rule_type === 'total_spend' ? 'e.g. 1000' : 'e.g. 5'}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                    <p className="text-xs text-gray-500 mt-1">
                                        {String(achievementFormData.target_value || '').length}/{MAX_LENGTHS.targetValue} digits
                                    </p>
                                </div>

                                {/* Timeframe */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Timeframe</label>
                                    <select
                                        value={achievementFormData.timeframe_type}
                                        onChange={(e) => setAchievementFormData({ ...achievementFormData, timeframe_type: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    >
                                        <option value="none">Permanent</option>
                                        <option value="daily">Daily</option>
                                        <option value="weekly">Weekly</option>
                                        <option value="monthly">Monthly</option>
                                    </select>
                                </div>
                            </div>

                            {/* Category Name — only for category_orders */}
                            {achievementFormData.rule_type === 'category_orders' && (
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Item Category <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        value={achievementFormData.category_name}
                                        onChange={(e) => setAchievementFormData({ ...achievementFormData, category_name: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    >
                                        <option value="">Select category</option>
                                        {menuCategories.map((cat) => (
                                            <option key={cat} value={cat}>{cat}</option>
                                        ))}
                                    </select>
                                    {menuCategories.length === 0 && (
                                        <p className="text-xs text-gray-500 mt-1">No categories found in menu.</p>
                                    )}
                                </div>
                            )}

                            {/* Branch — only for branch_visits */}
                            {achievementFormData.rule_type === 'branch_visits' && (
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Specific Branch <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        value={achievementFormData.branch_id}
                                        onChange={(e) => setAchievementFormData({ ...achievementFormData, branch_id: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    >
                                        <option value="">Any branch</option>
                                        {branches.map((branch) => (
                                            <option key={branch.branch_id} value={branch.branch_id}>{branch.name}</option>
                                        ))}
                                    </select>
                                </div>
                            )}

                            {/* Auto-generated condition label preview */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Condition Label</label>
                                <input
                                    type="text"
                                    value={achievementFormData.condition_label}
                                    onChange={(e) => setAchievementFormData({ ...achievementFormData, condition_label: e.target.value })}
                                    placeholder="Auto-filled or write a custom label"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C] bg-gray-50"
                                />
                                <p className="text-xs text-gray-500 mt-1">{achievementFormData.condition_label.length}/{MAX_LENGTHS.achievementCondition} characters</p>
                                <p className="text-xs text-gray-500">Shown to customers. Leave blank to auto-generate.</p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Badge Image</label>

                                <div className="inline-flex mb-3 rounded-lg bg-gray-100 p-1">
                                    <button
                                        type="button"
                                        onClick={() => setAchievementImageInputMode('upload')}
                                        className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${achievementImageInputMode === 'upload'
                                                ? 'bg-[#8B5A3C] text-white shadow-sm'
                                                : 'bg-transparent text-gray-600 hover:text-gray-800'
                                            }`}
                                    >
                                        Upload Image
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => setAchievementImageInputMode('url')}
                                        className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${achievementImageInputMode === 'url'
                                                ? 'bg-[#8B5A3C] text-white shadow-sm'
                                                : 'bg-transparent text-gray-600 hover:text-gray-800'
                                            }`}
                                    >
                                        Use Image URL
                                    </button>
                                </div>

                                {achievementImageInputMode === 'upload' ? (
                                    <div className="space-y-2">
                                        <input
                                            type="file"
                                            accept="image/png,image/jpeg,image/webp"
                                            onChange={(e) => setAchievementImageFile(e.target.files?.[0] || null)}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                        />
                                        <p className="text-xs text-gray-500">Accepted: JPG, PNG, WEBP. Max size: 5MB.</p>
                                    </div>
                                ) : (
                                    <input
                                        type="text"
                                        value={achievementFormData.image_url}
                                        onChange={(e) => setAchievementFormData({ ...achievementFormData, image_url: e.target.value })}
                                        placeholder="https://example.com/badge.png"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                )}

                                {(achievementFormData.image_url || achievementImageFile) && (
                                    <p className="text-xs text-gray-500 mt-2">
                                        {achievementImageFile ? `Selected file: ${achievementImageFile.name}` : 'Image URL provided'}
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3 flex-shrink-0">
                            <button
                                onClick={() => { setShowEditAchievementModal(false); setEditingAchievement(null); resetAchievementForm() }}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleUpdateAchievement}
                                disabled={!hasEditAchievementChanges}
                                className={`px-6 py-2 rounded-lg font-medium ${!hasEditAchievementChanges
                                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                        : 'bg-[#8B5A3C] text-white hover:bg-[#6d4730]'
                                    }`}
                            >
                                Save Changes
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Add Reward Modal */}
            {showAddRewardModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => { setShowAddRewardModal(false); resetRewardForm() }}></div>
                    <div className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4 flex-shrink-0">
                            <h2 className="text-xl font-bold text-gray-800">Add Reward</h2>
                            <p className="text-sm text-gray-500 mt-1">Set up a new reward, its redemption logic, value, and where it's available.</p>
                        </div>

                        <div className="px-6 py-6 space-y-4 overflow-y-auto flex-1">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Reward Name <span className="text-red-500">*</span></label>
                                <input
                                    type="text"
                                    value={rewardFormData.name}
                                    onChange={(e) => setRewardFormData({ ...rewardFormData, name: e.target.value })}
                                    maxLength={MAX_LENGTHS.rewardName}
                                    placeholder="Enter reward name"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                />
                                <p className="text-xs text-gray-500 mt-1">{rewardFormData.name.length}/{MAX_LENGTHS.rewardName} characters</p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Description <span className="text-red-500">*</span></label>
                                <textarea
                                    value={rewardFormData.description}
                                    onChange={(e) => setRewardFormData({ ...rewardFormData, description: e.target.value })}
                                    rows="4"
                                    maxLength={MAX_LENGTHS.rewardDescription}
                                    placeholder="Describe the reward"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                ></textarea>
                                <p className="text-xs text-gray-500 mt-1">{rewardFormData.description.length}/{MAX_LENGTHS.rewardDescription} characters</p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Mechanics / Guidelines <span className="text-red-500">*</span></label>
                                <textarea
                                    value={rewardFormData.mechanics}
                                    onChange={(e) => setRewardFormData({ ...rewardFormData, mechanics: e.target.value })}
                                    rows="5"
                                    maxLength={MAX_LENGTHS.rewardGuidelines}
                                    placeholder="State the reward rules, claiming mechanics, limitations, exclusions, and validity."
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                ></textarea>
                                <p className="text-xs text-gray-500 mt-1">{rewardFormData.mechanics.length}/{MAX_LENGTHS.rewardGuidelines} characters</p>
                            </div>



                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                {/* Single dropdown — replaces both duplicates */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Reward Type <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        value={rewardFormData.reward_logic_type}
                                        onChange={(e) => setRewardFormData({
                                            ...rewardFormData,
                                            reward_logic_type: e.target.value,
                                            points_required: '',
                                            min_order_count: '',
                                            min_total_spent: '',
                                            achievement_id: ''
                                        })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                    >
                                        <option value="point">Point (Redeem using points)</option>
                                        <option value="order">Order (Based on purchases)</option>
                                        <option value="achievement">Achievement (Badge unlock)</option>
                                        <option value="promo">Promo (Campaign-based)</option>
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Availability <span className="text-red-500">*</span></label>
                                    <select
                                        value={rewardFormData.rewardDurationType}
                                        onChange={(e) =>
                                            setRewardFormData({
                                                ...rewardFormData,
                                                rewardDurationType: e.target.value,
                                                startDate: e.target.value === 'Limited' ? rewardFormData.startDate : '',
                                                endDate: e.target.value === 'Limited' ? rewardFormData.endDate : ''
                                            })
                                        }
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    >
                                        <option value="Permanent">Permanent</option>
                                        <option value="Limited">Limited</option>
                                    </select>
                                </div>
                            </div>

                            {rewardFormData.reward_logic_type === 'achievement' && (
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Required Achievement <span className="text-red-500">*</span>
                                    </label>
                                    {(() => {
                                        const selectedAchievement = achievements.find(a => a.id === rewardFormData.achievement_id)
                                        return selectedAchievement ? (
                                            <div className="flex items-center justify-between px-3 py-2 border border-[#8B5A3C] bg-[#F3EAE4] rounded-lg">
                                                <div>
                                                    <p className="text-sm font-medium text-[#8B5A3C]">{selectedAchievement.title}</p>
                                                    <p className="text-xs text-gray-500">{selectedAchievement.condition}</p>
                                                </div>
                                                <button
                                                    type="button"
                                                    onClick={() => setRewardFormData({ ...rewardFormData, achievement_id: '' })}
                                                    className="text-sm font-medium text-red-600 hover:underline"
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="space-y-2">
                                                <input
                                                    type="text"
                                                    value={achievementSearch}
                                                    onChange={(e) => setAchievementSearch(e.target.value)}
                                                    placeholder="Search achievements by title..."
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                                />
                                                <div className="max-h-48 overflow-y-auto border border-gray-200 rounded-lg divide-y divide-gray-100">
                                                    {achievements
                                                        .filter(a =>
                                                            !achievementSearch ||
                                                            a.title.toLowerCase().includes(achievementSearch.toLowerCase()) ||
                                                            a.condition.toLowerCase().includes(achievementSearch.toLowerCase())
                                                        )
                                                        .length === 0 ? (
                                                        <div className="px-3 py-3 text-sm text-gray-500">No achievements found.</div>
                                                    ) : (
                                                        achievements
                                                            .filter(a =>
                                                                !achievementSearch ||
                                                                a.title.toLowerCase().includes(achievementSearch.toLowerCase()) ||
                                                                a.condition.toLowerCase().includes(achievementSearch.toLowerCase())
                                                            )
                                                            .map((a) => (
                                                                <button
                                                                    key={a.id}
                                                                    type="button"
                                                                    onClick={() => {
                                                                        setRewardFormData({ ...rewardFormData, achievement_id: a.id })
                                                                        setAchievementSearch('')
                                                                    }}
                                                                    className="w-full text-left px-3 py-2 hover:bg-gray-50"
                                                                >
                                                                    <p className="text-sm font-medium text-gray-800">{a.title}</p>
                                                                    <p className="text-xs text-gray-500">{a.condition}</p>
                                                                </button>
                                                            ))
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    })()}
                                </div>
                            )}

                            {rewardFormData.reward_logic_type === 'promo' && (
                                <div className="space-y-4">
                                    <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg text-sm text-blue-700">
                                        This reward activates when a linked campaign is running. The conditions below determine customer eligibility.
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Minimum Order Count
                                            </label>
                                            <input
                                                type="number"
                                                min="0"
                                                value={rewardFormData.promo_min_order_count}
                                                onChange={(e) => {
                                                    if (e.target.value.length <= MAX_LENGTHS.promoMinOrderCount) {
                                                        setRewardFormData({ ...rewardFormData, promo_min_order_count: e.target.value })
                                                    }
                                                }}
                                                onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                                                placeholder="e.g. 3 — leave blank if none"
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                            />
                                            <p className="text-xs text-gray-500 mt-1">Customer must have completed this many orders to qualify.</p>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Minimum Spend (₱)
                                            </label>
                                            <input
                                                type="number"
                                                min="0"
                                                step="0.01"
                                                value={rewardFormData.minimum_spend}
                                                onChange={(e) => {
                                                    if (e.target.value.length <= MAX_LENGTHS.minimumSpend) {
                                                        setRewardFormData({ ...rewardFormData, minimum_spend: e.target.value })
                                                    }
                                                }}
                                                onKeyDown={(e) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                                                placeholder="e.g. 500 — leave blank if none"
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                            />
                                            <p className="text-xs text-gray-500 mt-1">Customer's order must reach this amount to qualify.</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Conditional fields */}
                            {rewardFormData.reward_logic_type === 'point' && (
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Points Required <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min="0"
                                        value={rewardFormData.points_required}
                                        onChange={(e) => {
                                            if (e.target.value.length <= MAX_LENGTHS.pointsRequired) {
                                                setRewardFormData({ ...rewardFormData, points_required: e.target.value })
                                            }
                                        }}
                                        placeholder="e.g. 500"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                    />
                                    <p className="text-xs text-gray-500 mt-1">
                                        {String(rewardFormData.points_required || '').length}/{MAX_LENGTHS.pointsRequired} digits
                                    </p>
                                </div>
                            )}

                            {rewardFormData.reward_logic_type === 'order' && (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Minimum Order Count <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            min="0"
                                            value={rewardFormData.min_order_count}
                                            onChange={(e) => {
                                                if (e.target.value.length <= MAX_LENGTHS.pointsRequired) {
                                                    setRewardFormData({ ...rewardFormData, min_order_count: e.target.value })
                                                }
                                            }}
                                            placeholder="e.g. 5"
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                        />
                                        <p className="text-xs text-gray-500 mt-1">
                                            Customer must order item(s) at least this amount in an order to apply this reward.
                                        </p>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Minimum Total Spent (₱) <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            min="0"
                                            value={rewardFormData.min_total_spent}
                                            onChange={(e) => {
                                                if (e.target.value.length <= MAX_LENGTHS.minimumSpend) {
                                                    setRewardFormData({ ...rewardFormData, min_total_spent: e.target.value })
                                                }
                                            }}
                                            placeholder="e.g. 1000"
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                        />
                                        <p className="text-xs text-gray-500 mt-1">
                                            Customer must spend at least this amount in an order to apply this reward.
                                        </p>
                                    </div>
                                </div>
                            )}

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Reward Value Type
                                    </label>

                                    <select
                                        value={rewardFormData.reward_value_type}
                                        onChange={(e) =>
                                            setRewardFormData({
                                                ...rewardFormData,
                                                reward_value_type: e.target.value,
                                                reward_value: ''
                                            })
                                        }
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                    >
                                        <option value="">Select Type</option>
                                        <option value="fixed_amount">Fixed Amount (₱)</option>
                                        <option value="percentage">Percentage (%)</option>
                                        <option value="bonus_points">Bonus Points</option>
                                    </select>
                                </div>

                                {rewardFormData.reward_value_type === 'fixed_amount' && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Discount Amount (₱) <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            value={rewardFormData.reward_value}
                                            onChange={(e) => {
                                                if (e.target.value.length <= MAX_LENGTHS.rewardValue) {
                                                    setRewardFormData({ ...rewardFormData, reward_value: e.target.value })
                                                }
                                            }}
                                            placeholder="e.g. 50.00"
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                        />
                                    </div>
                                )}

                                {rewardFormData.reward_value_type === 'percentage' && (
                                    <>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Discount Percentage (%) <span className="text-red-500">*</span>
                                            </label>
                                            <input
                                                type="number"
                                                min="1"
                                                max="100"
                                                value={rewardFormData.reward_value}
                                                onChange={(e) => {
                                                    if (e.target.value.length <= MAX_LENGTHS.rewardValue) {
                                                        setRewardFormData({ ...rewardFormData, reward_value: e.target.value })
                                                    }
                                                }}
                                                placeholder="e.g. 10"
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Max Discount Cap (₱) <span className="text-xs text-gray-500">(optional — leave blank for no cap)</span>
                                            </label>
                                            <input
                                                type="number"
                                                min="0"
                                                step="0.01"
                                                value={rewardFormData.max_discount_amount}
                                                onChange={(e) => setRewardFormData({ ...rewardFormData, max_discount_amount: e.target.value })}
                                                placeholder="e.g. 200.00"
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                            />
                                            <p className="text-xs text-gray-500 mt-1">The discount from this % will never exceed this amount.</p>
                                        </div>
                                    </>
                                )}

                                {rewardFormData.reward_value_type === 'bonus_points' && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Bonus Points to Grant <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            min="1"
                                            value={rewardFormData.reward_value}
                                            onChange={(e) => {
                                                if (e.target.value.length <= MAX_LENGTHS.bonusPoints) {
                                                    setRewardFormData({ ...rewardFormData, reward_value: e.target.value })
                                                }
                                            }}
                                            onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                                            placeholder="e.g. 100"
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                        />
                                        <p className="text-xs text-gray-500 mt-1">Points granted to the customer when this reward is redeemed.</p>
                                    </div>
                                )}
                            </div>

                            {/* Reward Application Scope */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Reward Applies To <span className="text-red-500">*</span>
                                </label>
                                <select
                                    value={rewardFormData.application_scope}
                                    onChange={(e) =>
                                        setRewardFormData({
                                            ...rewardFormData,
                                            application_scope: e.target.value,
                                            applies_to_category: e.target.value === 'category' ? rewardFormData.applies_to_category : ''
                                        })
                                    }
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                >
                                    <option value="all">All Menu Items</option>
                                    <option value="category">Specific Category</option>
                                    <option value="specific_items">Specific Item(s)</option>
                                </select>
                            </div>

                            {rewardFormData.application_scope === 'category' && (
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Item Category <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        value={rewardFormData.applies_to_category}
                                        onChange={(e) => setRewardFormData({ ...rewardFormData, applies_to_category: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    >
                                        <option value="">Select category</option>
                                        {menuCategories.map((cat) => (
                                            <option key={cat} value={cat}>{cat}</option>
                                        ))}
                                    </select>
                                </div>
                            )}

                            {rewardFormData.application_scope === 'specific_items' && (
                                <>
                                    {/* Linked Menu */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Linked Menu Items <span className="text-xs text-gray-500">(optional — the reward will apply to these items; leave empty for no specific item)</span>
                                        </label>

                                        <div className="space-y-3">
                                            {rewardLinkedItems.map((row, index) => (
                                                <div key={index} className="border border-gray-200 rounded-lg p-3 relative">
                                                    <button
                                                        type="button"
                                                        onClick={() => removeRewardLinkedItemRow(index)}
                                                        className="absolute top-2 right-2 text-xs font-medium text-red-600 hover:underline"
                                                    >
                                                        Remove
                                                    </button>
                                                    {renderLinkedItemPicker({
                                                        itemId: row.item_id,
                                                        variantId: row.variant_id,
                                                        onSelectItem: (id) => updateRewardLinkedItemRow(index, { item_id: id, variant_id: '' }),
                                                        onSelectVariant: (id) => updateRewardLinkedItemRow(index, { variant_id: id }),
                                                        onClear: () => updateRewardLinkedItemRow(index, { item_id: '', variant_id: '' }),
                                                        search: linkedItemSearch,
                                                        setSearch: setLinkedItemSearch,
                                                        page: rewardLinkedItemPickerPage,
                                                        setPage: setRewardLinkedItemPickerPage
                                                    })}
                                                </div>
                                            ))}
                                        </div>

                                        <button
                                            type="button"
                                            onClick={addRewardLinkedItemRow}
                                            className="mt-3 text-sm font-medium text-[#8B5A3C] hover:underline"
                                        >
                                            + Link Another Item
                                        </button>
                                    </div>
                                </>
                            )}

                            {rewardFormData.rewardDurationType === 'Limited' && (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Start Date <span className="text-red-500">*</span></label>
                                        <input
                                            type="date"
                                            value={rewardFormData.startDate}
                                            onChange={(e) => setRewardFormData({ ...rewardFormData, startDate: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">End Date <span className="text-red-500">*</span></label>
                                        <input
                                            type="date"
                                            value={rewardFormData.endDate}
                                            onChange={(e) => setRewardFormData({ ...rewardFormData, endDate: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                        />
                                    </div>
                                </div>
                            )}

                            {/* is_featured on Mobile App */}
                            <div className="flex items-center gap-2">
                                <input
                                    type="checkbox"
                                    id="is_featured_add"
                                    checked={rewardFormData.is_featured}
                                    onChange={(e) => setRewardFormData({ ...rewardFormData, is_featured: e.target.checked })}
                                    className="w-4 h-4 accent-[#8B5A3C]"
                                />
                                <label htmlFor="is_featured_add" className="text-sm font-medium text-gray-700">
                                    Feature this reward on the customer app
                                </label>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Status <span className="text-red-500">*</span></label>
                                <select
                                    value={rewardFormData.status}
                                    onChange={(e) => setRewardFormData({ ...rewardFormData, status: e.target.value })}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                >
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                            </div>
                            {renderBranchSelector()}
                        </div>

                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3 flex-shrink-0">
                            <button
                                onClick={() => { setShowAddRewardModal(false); resetRewardForm() }}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleAddReward}
                                disabled={!hasAddRewardChanges}
                                className={`px-6 py-2 rounded-lg font-medium ${!hasAddRewardChanges
                                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                        : 'bg-[#8B5A3C] text-white hover:bg-[#6d4730]'
                                    }`}
                            >
                                Save Reward
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Reward Modal */}
            {showEditRewardModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => { setShowEditRewardModal(false); setEditingReward(null); resetRewardForm() }}></div>
                    <div className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4 flex-shrink-0">
                            <h2 className="text-xl font-bold text-gray-800">Edit Reward</h2>
                            <p className="text-sm text-gray-500 mt-1">Update this reward's details, redemption rules, or branch availability.</p>
                        </div>

                        <div className="px-6 py-6 space-y-4 overflow-y-auto flex-1">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Reward Name <span className="text-red-500">*</span></label>
                                <input
                                    type="text"
                                    value={rewardFormData.name}
                                    onChange={(e) => setRewardFormData({ ...rewardFormData, name: e.target.value })}
                                    maxLength={MAX_LENGTHS.rewardName}
                                    placeholder="Enter reward name"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                />
                                <p className="text-xs text-gray-500 mt-1">{rewardFormData.name.length}/{MAX_LENGTHS.rewardName} characters</p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Description <span className="text-red-500">*</span></label>
                                <textarea
                                    value={rewardFormData.description}
                                    onChange={(e) => setRewardFormData({ ...rewardFormData, description: e.target.value })}
                                    rows="4"
                                    maxLength={MAX_LENGTHS.rewardDescription}
                                    placeholder="Describe the reward"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                ></textarea>
                                <p className="text-xs text-gray-500 mt-1">{rewardFormData.description.length}/{MAX_LENGTHS.rewardDescription} characters</p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Mechanics / Guidelines <span className="text-red-500">*</span></label>
                                <textarea
                                    value={rewardFormData.mechanics}
                                    onChange={(e) => setRewardFormData({ ...rewardFormData, mechanics: e.target.value })}
                                    rows="5"
                                    maxLength={MAX_LENGTHS.rewardGuidelines}
                                    placeholder="State the reward rules, claiming mechanics, limitations, exclusions, and validity."
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                ></textarea>
                                <p className="text-xs text-gray-500 mt-1">{rewardFormData.mechanics.length}/{MAX_LENGTHS.rewardGuidelines} characters</p>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Reward Value Type
                                    </label>

                                    <select
                                        value={rewardFormData.reward_value_type}
                                        onChange={(e) =>
                                            setRewardFormData({
                                                ...rewardFormData,
                                                reward_value_type: e.target.value,
                                                reward_value: ''
                                            })
                                        }
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                    >
                                        <option value="">Select Type</option>
                                        <option value="fixed_amount">Fixed Amount (₱)</option>
                                        <option value="percentage">Percentage (%)</option>
                                        <option value="bonus_points">Bonus Points</option>
                                    </select>
                                </div>

                                {rewardFormData.reward_value_type === 'fixed_amount' && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Discount Amount (₱) <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            value={rewardFormData.reward_value}
                                            onChange={(e) => {
                                                if (e.target.value.length <= MAX_LENGTHS.rewardValue) {
                                                    setRewardFormData({ ...rewardFormData, reward_value: e.target.value })
                                                }
                                            }}
                                            placeholder="e.g. 50.00"
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                        />
                                    </div>
                                )}

                                {rewardFormData.reward_value_type === 'percentage' && (
                                    <>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Discount Percentage (%) <span className="text-red-500">*</span>
                                            </label>
                                            <input
                                                type="number"
                                                min="1"
                                                max="100"
                                                value={rewardFormData.reward_value}
                                                onChange={(e) => {
                                                    if (e.target.value.length <= MAX_LENGTHS.rewardValue) {
                                                        setRewardFormData({ ...rewardFormData, reward_value: e.target.value })
                                                    }
                                                }}
                                                placeholder="e.g. 10"
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Max Discount Cap (₱) <span className="text-xs text-gray-500">(optional — leave blank for no cap)</span>
                                            </label>
                                            <input
                                                type="number"
                                                min="0"
                                                step="0.01"
                                                value={rewardFormData.max_discount_amount}
                                                onChange={(e) => setRewardFormData({ ...rewardFormData, max_discount_amount: e.target.value })}
                                                placeholder="e.g. 200.00"
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                            />
                                            <p className="text-xs text-gray-500 mt-1">The discount from this % will never exceed this amount.</p>
                                        </div>
                                    </>
                                )}

                                {rewardFormData.reward_value_type === 'bonus_points' && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Bonus Points to Grant <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            min="1"
                                            value={rewardFormData.reward_value}
                                            onChange={(e) => {
                                                if (e.target.value.length <= MAX_LENGTHS.bonusPoints) {
                                                    setRewardFormData({ ...rewardFormData, reward_value: e.target.value })
                                                }
                                            }}
                                            onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                                            placeholder="e.g. 100"
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                        />
                                        <p className="text-xs text-gray-500 mt-1">Points granted to the customer when this reward is redeemed.</p>
                                    </div>
                                )}
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Reward Type <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        value={rewardFormData.reward_logic_type}
                                        onChange={(e) => setRewardFormData({
                                            ...rewardFormData,
                                            reward_logic_type: e.target.value,
                                            points_required: '',
                                            min_order_count: '',
                                            min_total_spent: '',
                                            achievement_id: ''
                                        })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                    >
                                        <option value="point">Point (Redeem using points)</option>
                                        <option value="order">Order (Based on purchases)</option>
                                        <option value="achievement">Achievement (Badge unlock)</option>
                                        <option value="promo">Promo (Campaign-based)</option>
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Availability <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        value={rewardFormData.rewardDurationType}
                                        onChange={(e) => setRewardFormData({
                                            ...rewardFormData,
                                            rewardDurationType: e.target.value,
                                            startDate: e.target.value === 'Limited' ? rewardFormData.startDate : '',
                                            endDate: e.target.value === 'Limited' ? rewardFormData.endDate : ''
                                        })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                    >
                                        <option value="Permanent">Permanent</option>
                                        <option value="Limited">Limited</option>
                                    </select>
                                </div>
                            </div>

                            {/* Conditional fields */}
                            {rewardFormData.reward_logic_type === 'point' && (
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Points Required <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min="0"
                                        value={rewardFormData.points_required}
                                        onChange={(e) => setRewardFormData({ ...rewardFormData, points_required: e.target.value })}
                                        placeholder="e.g. 500"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                    />
                                    <p className="text-xs text-gray-500 mt-1">
                                        {String(rewardFormData.points_required || '').length}/{MAX_LENGTHS.pointsRequired} digits
                                    </p>
                                </div>
                            )}

                            {rewardFormData.reward_logic_type === 'order' && (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Minimum Order Count
                                        </label>
                                        <input
                                            type="number"
                                            min="0"
                                            value={rewardFormData.min_order_count}
                                            onChange={(e) => setRewardFormData({ ...rewardFormData, min_order_count: e.target.value })}
                                            placeholder="e.g. 5"
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                        />
                                        <p className="text-xs text-gray-500 mt-1">
                                            Customer must order item(s) at least this amount in an order to apply this reward.
                                        </p>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Minimum Total Spent (₱)
                                        </label>
                                        <input
                                            type="number"
                                            min="0"
                                            value={rewardFormData.min_total_spent}
                                            onChange={(e) => setRewardFormData({ ...rewardFormData, min_total_spent: e.target.value })}
                                            placeholder="e.g. 1000"
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                                        />
                                        <p className="text-xs text-gray-500 mt-1">
                                            Customer must spend at least this amount in an order to apply this reward.
                                        </p>
                                    </div>
                                </div>
                            )}

                            {rewardFormData.reward_logic_type === 'achievement' && (
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Required Achievement <span className="text-red-500">*</span>
                                    </label>
                                    {(() => {
                                        const selectedAchievement = achievements.find(a => a.id === rewardFormData.achievement_id)
                                        return selectedAchievement ? (
                                            <div className="flex items-center justify-between px-3 py-2 border border-[#8B5A3C] bg-[#F3EAE4] rounded-lg">
                                                <div>
                                                    <p className="text-sm font-medium text-[#8B5A3C]">{selectedAchievement.title}</p>
                                                    <p className="text-xs text-gray-500">{selectedAchievement.condition}</p>
                                                </div>
                                                <button
                                                    type="button"
                                                    onClick={() => setRewardFormData({ ...rewardFormData, achievement_id: '' })}
                                                    className="text-sm font-medium text-red-600 hover:underline"
                                                >
                                                    Remove
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="space-y-2">
                                                <input
                                                    type="text"
                                                    value={achievementSearch}
                                                    onChange={(e) => setAchievementSearch(e.target.value)}
                                                    placeholder="Search achievements by title..."
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                                />
                                                <div className="max-h-48 overflow-y-auto border border-gray-200 rounded-lg divide-y divide-gray-100">
                                                    {achievements
                                                        .filter(a =>
                                                            !achievementSearch ||
                                                            a.title.toLowerCase().includes(achievementSearch.toLowerCase()) ||
                                                            a.condition.toLowerCase().includes(achievementSearch.toLowerCase())
                                                        )
                                                        .length === 0 ? (
                                                        <div className="px-3 py-3 text-sm text-gray-500">No achievements found.</div>
                                                    ) : (
                                                        achievements
                                                            .filter(a =>
                                                                !achievementSearch ||
                                                                a.title.toLowerCase().includes(achievementSearch.toLowerCase()) ||
                                                                a.condition.toLowerCase().includes(achievementSearch.toLowerCase())
                                                            )
                                                            .map((a) => (
                                                                <button
                                                                    key={a.id}
                                                                    type="button"
                                                                    onClick={() => {
                                                                        setRewardFormData({ ...rewardFormData, achievement_id: a.id })
                                                                        setAchievementSearch('')
                                                                    }}
                                                                    className="w-full text-left px-3 py-2 hover:bg-gray-50"
                                                                >
                                                                    <p className="text-sm font-medium text-gray-800">{a.title}</p>
                                                                    <p className="text-xs text-gray-500">{a.condition}</p>
                                                                </button>
                                                            ))
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    })()}
                                </div>
                            )}

                            {rewardFormData.reward_logic_type === 'promo' && (
                                <div className="space-y-4">
                                    <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg text-sm text-blue-700">
                                        This reward activates when a linked campaign is running. The conditions below determine customer eligibility.
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Minimum Order Count
                                            </label>
                                            <input
                                                type="number"
                                                min="0"
                                                value={rewardFormData.promo_min_order_count}
                                                onChange={(e) => {
                                                    if (e.target.value.length <= MAX_LENGTHS.promoMinOrderCount) {
                                                        setRewardFormData({ ...rewardFormData, promo_min_order_count: e.target.value })
                                                    }
                                                }}
                                                onKeyDown={(e) => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault()}
                                                placeholder="e.g. 3 — leave blank if none"
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                            />
                                            <p className="text-xs text-gray-500 mt-1">Customer must have completed this many orders to qualify.</p>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                Minimum Spend (₱)
                                            </label>
                                            <input
                                                type="number"
                                                min="0"
                                                step="0.01"
                                                value={rewardFormData.minimum_spend}
                                                onChange={(e) => {
                                                    if (e.target.value.length <= MAX_LENGTHS.minimumSpend) {
                                                        setRewardFormData({ ...rewardFormData, minimum_spend: e.target.value })
                                                    }
                                                }}
                                                onKeyDown={(e) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                                                placeholder="e.g. 500 — leave blank if none"
                                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                            />
                                            <p className="text-xs text-gray-500 mt-1">Customer's order must reach this amount to qualify.</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Reward Applies To <span className="text-red-500">*</span>
                                </label>
                                <select
                                    value={rewardFormData.application_scope}
                                    onChange={(e) =>
                                        setRewardFormData({
                                            ...rewardFormData,
                                            application_scope: e.target.value,
                                            applies_to_category: e.target.value === 'category' ? rewardFormData.applies_to_category : ''
                                        })
                                    }
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                >
                                    <option value="all">All Menu Items</option>
                                    <option value="category">Specific Category</option>
                                    <option value="specific_items">Specific Item(s)</option>
                                </select>
                            </div>

                            {rewardFormData.application_scope === 'category' && (
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Item Category <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        value={rewardFormData.applies_to_category}
                                        onChange={(e) => setRewardFormData({ ...rewardFormData, applies_to_category: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    >
                                        <option value="">Select category</option>
                                        {menuCategories.map((cat) => (
                                            <option key={cat} value={cat}>{cat}</option>
                                        ))}
                                    </select>
                                </div>
                            )}

                            {rewardFormData.application_scope === 'specific_items' && (
                                <>
                                    {/* Linked Menu Items */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Linked Menu Items <span className="text-xs text-gray-500">(optional — the reward will apply to these items; leave empty for no specific item)</span>
                                        </label>

                                        <div className="space-y-3">
                                            {rewardLinkedItems.map((row, index) => (
                                                <div key={index} className="border border-gray-200 rounded-lg p-3 relative">
                                                    <button
                                                        type="button"
                                                        onClick={() => removeRewardLinkedItemRow(index)}
                                                        className="absolute top-2 right-2 text-xs font-medium text-red-600 hover:underline"
                                                    >
                                                        Remove
                                                    </button>
                                                    {renderLinkedItemPicker({
                                                        itemId: row.item_id,
                                                        variantId: row.variant_id,
                                                        onSelectItem: (id) => updateRewardLinkedItemRow(index, { item_id: id, variant_id: '' }),
                                                        onSelectVariant: (id) => updateRewardLinkedItemRow(index, { variant_id: id }),
                                                        onClear: () => updateRewardLinkedItemRow(index, { item_id: '', variant_id: '' }),
                                                        search: linkedItemSearch,
                                                        setSearch: setLinkedItemSearch,
                                                        page: rewardLinkedItemPickerPage,
                                                        setPage: setRewardLinkedItemPickerPage
                                                    })}
                                                </div>
                                            ))}
                                        </div>

                                        <button
                                            type="button"
                                            onClick={addRewardLinkedItemRow}
                                            className="mt-3 text-sm font-medium text-[#8B5A3C] hover:underline"
                                        >
                                            + Link Another Item
                                        </button>
                                    </div>
                                </>
                            )}

                            {rewardFormData.rewardDurationType === 'Limited' && (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Start Date <span className="text-red-500">*</span></label>
                                        <input
                                            type="date"
                                            value={rewardFormData.startDate}
                                            onChange={(e) => setRewardFormData({ ...rewardFormData, startDate: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">End Date <span className="text-red-500">*</span></label>
                                        <input
                                            type="date"
                                            value={rewardFormData.endDate}
                                            onChange={(e) => setRewardFormData({ ...rewardFormData, endDate: e.target.value })}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                        />
                                    </div>
                                </div>
                            )}

                            {/* is_featured on Mobile App */}
                            <div className="flex items-center gap-2">
                                <input
                                    type="checkbox"
                                    id="is_featured_edit"
                                    checked={rewardFormData.is_featured}
                                    onChange={(e) => setRewardFormData({ ...rewardFormData, is_featured: e.target.checked })}
                                    className="w-4 h-4 accent-[#8B5A3C]"
                                />
                                <label htmlFor="is_featured_edit" className="text-sm font-medium text-gray-700">
                                    Feature this reward on the customer app
                                </label>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Status <span className="text-red-500">*</span></label>
                                <select
                                    value={rewardFormData.status}
                                    onChange={(e) => setRewardFormData({ ...rewardFormData, status: e.target.value })}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                >
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                            </div>
                            {renderBranchSelector()}
                        </div>

                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3 flex-shrink-0">
                            <button
                                onClick={() => { setShowEditRewardModal(false); setEditingReward(null); resetRewardForm() }}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleUpdateReward}
                                disabled={!hasEditRewardChanges}
                                className={`px-6 py-2 rounded-lg font-medium ${!hasEditRewardChanges
                                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                        : 'bg-[#8B5A3C] text-white hover:bg-[#6d4730]'
                                    }`}
                            >
                                Save Changes
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Add Campaign Modal */}
            {showAddCampaignModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => { setShowAddCampaignModal(false); resetCampaignForm() }}></div>
                    <div className="relative bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4 flex-shrink-0">
                            <h2 className="text-xl font-bold text-gray-800">Create Campaign</h2>
                            <p className="text-sm text-gray-500 mt-1">Launch a promotion or challenge, optionally linked to a reward, for selected branches.</p>
                        </div>

                        <div className="px-6 py-6 space-y-4 overflow-y-auto flex-1">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Campaign Name <span className="text-red-500">*</span></label>
                                <input
                                    type="text"
                                    value={campaignFormData.name}
                                    onChange={(e) => setCampaignFormData({ ...campaignFormData, name: e.target.value })}
                                    maxLength={MAX_LENGTHS.campaignName}
                                    placeholder="Enter campaign name"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                />
                                <p className="text-xs text-gray-500 mt-1">{campaignFormData.name.length}/{MAX_LENGTHS.campaignName} characters</p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Description <span className="text-red-500">*</span></label>
                                <textarea
                                    value={campaignFormData.description}
                                    onChange={(e) => setCampaignFormData({ ...campaignFormData, description: e.target.value })}
                                    rows="4"
                                    maxLength={MAX_LENGTHS.campaignDescription}
                                    placeholder="Describe the campaign"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                ></textarea>
                                <p className="text-xs text-gray-500 mt-1">{campaignFormData.description.length}/{MAX_LENGTHS.campaignDescription} characters</p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Mechanics / Guidelines <span className="text-red-500">*</span></label>
                                <textarea
                                    value={campaignFormData.mechanics}
                                    onChange={(e) => setCampaignFormData({ ...campaignFormData, mechanics: e.target.value })}
                                    rows="6"
                                    maxLength={MAX_LENGTHS.campaignGuidelines}
                                    placeholder="State the campaign rules, eligibility, exclusions, qualifications, and claiming mechanics."
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                ></textarea>
                                <p className="text-xs text-gray-500 mt-1">{campaignFormData.mechanics.length}/{MAX_LENGTHS.campaignGuidelines} characters</p>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Campaign Type <span className="text-red-500">*</span></label>
                                    <select
                                        value={campaignFormData.type}
                                        onChange={(e) => setCampaignFormData({ ...campaignFormData, type: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    >
                                        <option value="Promotion">Promotion</option>
                                        <option value="Challenge">Challenge</option>
                                    </select>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Status <span className="text-red-500">*</span></label>
                                    <select
                                        value={campaignFormData.status}
                                        onChange={(e) => setCampaignFormData({ ...campaignFormData, status: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    >
                                        <option value="scheduled">Scheduled</option>
                                        <option value="active">Active</option>
                                        <option value="ended">Ended</option>
                                        <option value="cancelled">Cancelled</option>
                                    </select>
                                </div>
                            </div>

                            {renderRewardPicker()}

                            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Start Date <span className="text-red-500">*</span></label>
                                    <input
                                        type="date"
                                        value={campaignFormData.startDate}
                                        onChange={(e) => setCampaignFormData({ ...campaignFormData, startDate: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Start Time <span className="text-red-500">*</span></label>
                                    <input
                                        type="time"
                                        value={campaignFormData.startTime}
                                        onChange={(e) => setCampaignFormData({ ...campaignFormData, startTime: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">End Date <span className="text-red-500">*</span></label>
                                    <input
                                        type="date"
                                        value={campaignFormData.endDate}
                                        onChange={(e) => setCampaignFormData({ ...campaignFormData, endDate: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">End Time <span className="text-red-500">*</span></label>
                                    <input
                                        type="time"
                                        value={campaignFormData.endTime}
                                        onChange={(e) => setCampaignFormData({ ...campaignFormData, endTime: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                </div>
                            </div>

                            {renderBranchSelector()}
                        </div>

                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3 flex-shrink-0">
                            <button
                                onClick={() => { setShowAddCampaignModal(false); resetCampaignForm() }}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleAddCampaign}
                                disabled={!hasAddCampaignChanges}
                                className={`px-6 py-2 rounded-lg font-medium ${!hasAddCampaignChanges
                                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                        : 'bg-[#8B5A3C] text-white hover:bg-[#6d4730]'
                                    }`}
                            >
                                Save Campaign
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Campaign Modal */}
            {showEditCampaignModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={() => { setShowEditCampaignModal(false); setEditingCampaign(null); resetCampaignForm() }}></div>
                    <div className="relative bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4 flex-shrink-0">
                            <h2 className="text-xl font-bold text-gray-800">Edit Campaign</h2>
                            <p className="text-sm text-gray-500 mt-1">Update this campaign's schedule, linked reward, or branch availability.</p>
                        </div>

                        <div className="px-6 py-6 space-y-4 overflow-y-auto flex-1">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Campaign Name <span className="text-red-500">*</span></label>
                                <input
                                    type="text"
                                    value={campaignFormData.name}
                                    onChange={(e) => setCampaignFormData({ ...campaignFormData, name: e.target.value })}
                                    maxLength={MAX_LENGTHS.campaignName}
                                    placeholder="Enter campaign name"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                />
                                <p className="text-xs text-gray-500 mt-1">{campaignFormData.name.length}/{MAX_LENGTHS.campaignName} characters</p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Description <span className="text-red-500">*</span></label>
                                <textarea
                                    value={campaignFormData.description}
                                    onChange={(e) => setCampaignFormData({ ...campaignFormData, description: e.target.value })}
                                    rows="4"
                                    maxLength={MAX_LENGTHS.campaignDescription}
                                    placeholder="Describe the campaign"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                ></textarea>
                                <p className="text-xs text-gray-500 mt-1">{campaignFormData.description.length}/{MAX_LENGTHS.campaignDescription} characters</p>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Mechanics / Guidelines <span className="text-red-500">*</span></label>
                                <textarea
                                    value={campaignFormData.mechanics}
                                    onChange={(e) => setCampaignFormData({ ...campaignFormData, mechanics: e.target.value })}
                                    rows="6"
                                    maxLength={MAX_LENGTHS.campaignGuidelines}
                                    placeholder="State the campaign rules, eligibility, exclusions, qualifications, and claiming mechanics."
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                ></textarea>
                                <p className="text-xs text-gray-500 mt-1">
                                    {campaignFormData.mechanics.length}/{MAX_LENGTHS.campaignGuidelines} characters
                                </p>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Campaign Type <span className="text-red-500">*</span></label>
                                    <select
                                        value={campaignFormData.type}
                                        onChange={(e) => setCampaignFormData({ ...campaignFormData, type: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    >
                                        <option value="Promotion">Promotion</option>
                                        <option value="Challenge">Challenge</option>
                                    </select>
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Status <span className="text-red-500">*</span></label>
                                    <select
                                        value={campaignFormData.status}
                                        onChange={(e) => setCampaignFormData({ ...campaignFormData, status: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    >
                                        <option value="scheduled">Scheduled</option>
                                        <option value="active">Active</option>
                                        <option value="ended">Ended</option>
                                        <option value="cancelled">Cancelled</option>
                                    </select>
                                </div>
                            </div>

                            {renderRewardPicker()}

                            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Start Date <span className="text-red-500">*</span></label>
                                    <input
                                        type="date"
                                        value={campaignFormData.startDate}
                                        onChange={(e) => setCampaignFormData({ ...campaignFormData, startDate: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Start Time <span className="text-red-500">*</span></label>
                                    <input
                                        type="time"
                                        value={campaignFormData.startTime}
                                        onChange={(e) => setCampaignFormData({ ...campaignFormData, startTime: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">End Date <span className="text-red-500">*</span></label>
                                    <input
                                        type="date"
                                        value={campaignFormData.endDate}
                                        onChange={(e) => setCampaignFormData({ ...campaignFormData, endDate: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">End Time <span className="text-red-500">*</span></label>
                                    <input
                                        type="time"
                                        value={campaignFormData.endTime}
                                        onChange={(e) => setCampaignFormData({ ...campaignFormData, endTime: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                    />
                                </div>
                            </div>

                            {renderBranchSelector()}

                        </div>

                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3 flex-shrink-0">
                            <button
                                onClick={() => { setShowEditCampaignModal(false); setEditingCampaign(null); resetCampaignForm() }}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleUpdateCampaign}
                                disabled={!hasEditCampaignChanges}
                                className={`px-6 py-2 rounded-lg font-medium ${!hasEditCampaignChanges
                                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                        : 'bg-[#8B5A3C] text-white hover:bg-[#6d4730]'
                                    }`}
                            >
                                Save Changes
                            </button>
                        </div>
                    </div>
                </div>
            )}

                {/* Campaign Details Modal (read-only) */}
            {showCampaignDetailsModal && viewingCampaign && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={closeCampaignDetailsModal}></div>
                    <div className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
                            <h2 className="text-xl font-bold text-gray-800">Campaign Details</h2>
                            <button
                                onClick={closeCampaignDetailsModal}
                                className="text-gray-400 hover:text-gray-600"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                                </svg>
                            </button>
                        </div>

                        <div className="px-6 py-6 space-y-5">
                            <div>
                                <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">Campaign Name</p>
                                <p className="text-lg font-semibold text-gray-800">{viewingCampaign.name}</p>
                            </div>

                            <div className="flex flex-wrap gap-2">
                                <span className={`px-3 py-1 rounded-full text-xs font-medium ${getCampaignStatusColor(viewingCampaign.status)}`}>
                                    {viewingCampaign.status.charAt(0).toUpperCase() + viewingCampaign.status.slice(1)}
                                </span>
                                <span className="px-3 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                                    {viewingCampaign.type}
                                </span>
                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">                                <div>
                                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">Start</p>
                                    <p className="text-sm text-gray-800">
                                        {new Date(viewingCampaign.startDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                                        {viewingCampaign.startTime ? ` · ${viewingCampaign.startTime}` : ''}
                                    </p>
                                </div>
                                <div>
                                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">End</p>
                                    <p className="text-sm text-gray-800">
                                        {new Date(viewingCampaign.endDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                                        {viewingCampaign.endTime ? ` · ${viewingCampaign.endTime}` : ''}
                                    </p>
                                </div>
                            </div>

                            <div>
                                <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">Linked Reward</p>
                                <p className="text-sm text-gray-800">
                                    {viewingCampaign.linkedRewardId
                                        ? rewardsCatalog.find(r => r.id === viewingCampaign.linkedRewardId)?.name || 'Linked reward'
                                        : 'No linked reward'}
                                </p>
                            </div>

                            {viewingCampaign.description && (
                                <div>
                                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">Description</p>
                                    <p className="text-sm text-gray-700 whitespace-pre-wrap">{viewingCampaign.description}</p>
                                </div>
                            )}

                            {viewingCampaign.mechanics && (
                                <div>
                                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">Mechanics / Guidelines</p>
                                    <p className="text-sm text-gray-700 whitespace-pre-wrap">{viewingCampaign.mechanics}</p>
                                </div>
                            )}

                            {(viewingCampaign.minimumSpend || viewingCampaign.minOrderCount) && (
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">                                    {viewingCampaign.minimumSpend && (
                                        <div>
                                            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">Minimum Spend</p>
                                            <p className="text-sm text-gray-800">₱{viewingCampaign.minimumSpend}</p>
                                        </div>
                                    )}
                                    {viewingCampaign.minOrderCount && (
                                        <div>
                                            <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">Minimum Order Count</p>
                                            <p className="text-sm text-gray-800">{viewingCampaign.minOrderCount}</p>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end gap-3 flex-shrink-0">
                            <button
                                onClick={closeCampaignDetailsModal}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Archived Viewer Modal */}
            {showArchivedViewerModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <div className="absolute inset-0 bg-black bg-opacity-50" onClick={closeArchivedViewerModal}></div>

                    <div className="relative bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[85vh] overflow-hidden flex flex-col">
                        <div className="border-b border-gray-200 px-6 py-4 flex-shrink-0">
                            <h2 className="text-xl font-bold text-gray-800">
                                Archived {archivedViewerTab === 'tiers' ? 'Customer Tiers' : archivedViewerTab === 'achievements' ? 'Achievements' : archivedViewerTab === 'rewards' ? 'Rewards' : 'Campaigns'}
                            </h2>
                            <p className="text-sm text-gray-500 mt-1">Reinstate records to make them active again.</p>
                        </div>

                        <div className="px-6 py-3 border-b border-gray-200 flex items-center gap-3 flex-wrap">
                            <div className="relative flex-1 min-w-[200px]">
                                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                                        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6" />
                                    </svg>
                                </span>
                                <input
                                    type="text"
                                    placeholder={`Search archived ${archivedViewerTab}...`}
                                    value={archivedSearch}
                                    onChange={(e) => setArchivedSearch(e.target.value)}
                                    className="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#8B5A3C]"
                                />
                            </div>

                            {archivedViewerTab === 'rewards' && (
                                <select
                                    value={archivedRewardTypeFilter}
                                    onChange={(e) => setArchivedRewardTypeFilter(e.target.value)}
                                    className="px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#8B5A3C] bg-white"
                                >
                                    {REWARD_TYPE_FILTER_OPTIONS.map((opt) => (
                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                    ))}
                                </select>
                            )}

                            {archivedViewerTab === 'achievements' && (
                                <select
                                    value={archivedAchievementTypeFilter}
                                    onChange={(e) => setArchivedAchievementTypeFilter(e.target.value)}
                                    className="px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#8B5A3C] bg-white"
                                >
                                    {ACHIEVEMENT_TYPE_FILTER_OPTIONS.map((opt) => (
                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                    ))}
                                </select>
                            )}

                            {archivedViewerTab === 'campaigns' && (
                                <select
                                    value={archivedCampaignTypeFilter}
                                    onChange={(e) => setArchivedCampaignTypeFilter(e.target.value)}
                                    className="px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#8B5A3C] bg-white"
                                >
                                    <option value="All">All Types</option>
                                    <option value="Promotion">Promotion</option>
                                    <option value="Challenge">Challenge</option>
                                </select>
                            )}
                        </div>

                        <div className="overflow-y-auto flex-1">
                            {/* Tiers */}
                            {archivedViewerTab === 'tiers' && (
                                filteredArchivedTiers.length === 0 ? (
                                    <div className="px-6 py-10 text-center text-gray-500">
                                        {archivedSearch ? 'No archived tiers match your search.' : 'No archived tiers found.'}
                                    </div>
                                ) : (
                                    <>
                                    <table className="w-full">
                                        <thead className="bg-gray-50 border-b border-gray-200">
                                            <tr>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Tier</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Points Range</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200 bg-white">
                                            {pagedArchivedTiers.map((tier) => (
                                                <tr key={tier.tier_id}>
                                                    <td className="px-6 py-4">
                                                        <div className="flex items-center gap-3">
                                                            {tier.tier_icon && (
                                                                <img src={tier.tier_icon} alt={tier.tier_name} className="w-10 h-10 rounded-full object-cover" />
                                                            )}
                                                            <p className="font-medium text-gray-800">{tier.tier_name}</p>
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4 text-gray-700">{tier.points_required}+ pts</td>
                                                    <td className="px-6 py-4">
                                                        <button
                                                            onClick={() => handleReinstateTier(tier)}
                                                            className="px-3 py-1.5 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700"
                                                        >
                                                            Reinstate
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <Pagination
                                        page={archivedPage}
                                        totalItems={filteredArchivedTiers.length}
                                        pageSize={PAGE_SIZE}
                                        onPageChange={setArchivedPage}
                                    />
                                    </>
                                )
                            )}

                            {/* Achievements */}
                            {archivedViewerTab === 'achievements' && (
                                filteredArchivedAchievements.length === 0 ? (
                                    <div className="px-6 py-10 text-center text-gray-500">No archived achievements found.</div>
                                ) : (
                                    <>
                                    <table className="w-full">
                                        <thead className="bg-gray-50 border-b border-gray-200">
                                            <tr>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Achievement</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Condition</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Points</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200 bg-white">
                                            {pagedArchivedAchievements.map((achievement) => (
                                                <tr key={achievement.id}>
                                                    <td className="px-6 py-4">
                                                        <p className="font-medium text-gray-800">{achievement.title}</p>
                                                        <p className="text-sm text-gray-500">{achievement.description}</p>
                                                    </td>
                                                    <td className="px-6 py-4 text-sm text-gray-700">{achievement.condition}</td>
                                                    <td className="px-6 py-4 text-sm font-medium text-gray-800">{achievement.rewardPoints} pts</td>
                                                    <td className="px-6 py-4">
                                                        <button
                                                            onClick={() => handleReinstateAchievement(achievement.id)}
                                                            className="px-3 py-1.5 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700"
                                                        >
                                                            Reinstate
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                     </table>
                                    <Pagination
                                        page={archivedPage}
                                        totalItems={filteredArchivedAchievements.length}
                                        pageSize={PAGE_SIZE}
                                        onPageChange={setArchivedPage}
                                    />
                                    </>
                                )
                            )}

                            {/* Rewards */}
                            {archivedViewerTab === 'rewards' && (
                                filteredArchivedRewards.length === 0 ? (
                                    <div className="px-6 py-10 text-center text-gray-500">No archived rewards found.</div>
                                ) : (
                                    <>
                                    <table className="w-full">
                                        <thead className="bg-gray-50 border-b border-gray-200">
                                            <tr>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Reward</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Type</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Points</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200 bg-white">
                                            {pagedArchivedRewards.map((reward) => (
                                                <tr key={reward.id}>
                                                    <td className="px-6 py-4">
                                                        <p className="font-medium text-gray-800">{reward.name}</p>
                                                        <p className="text-sm text-gray-500">{reward.rewardDurationType}</p>
                                                    </td>
                                                    <td className="px-6 py-4 text-sm text-gray-700">{reward.category}</td>
                                                    <td className="px-6 py-4 text-sm font-medium text-gray-800">{reward.pointsRequired} pts</td>
                                                    <td className="px-6 py-4">
                                                        <button
                                                            onClick={() => handleReinstateReward(reward.id)}
                                                            className="px-3 py-1.5 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700"
                                                        >
                                                            Reinstate
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <Pagination
                                        page={archivedPage}
                                        totalItems={filteredArchivedRewards.length}
                                        pageSize={PAGE_SIZE}
                                        onPageChange={setArchivedPage}
                                    />
                                    </>
                                )
                            )}

                            {/* Campaigns */}
                            {archivedViewerTab === 'campaigns' && (
                                filteredArchivedCampaigns.length === 0 ? (
                                    <div className="px-6 py-10 text-center text-gray-500">No archived campaigns found.</div>
                                ) : (
                                    <>
                                    <table className="w-full">
                                        <thead className="bg-gray-50 border-b border-gray-200">
                                            <tr>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Campaign</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Type</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Dates</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200 bg-white">
                                            {pagedArchivedCampaigns.map((campaign) => (
                                                <tr key={campaign.id}>
                                                    <td className="px-6 py-4">
                                                        <p className="font-medium text-gray-800">{campaign.name}</p>
                                                        <p className="text-sm text-gray-500">
                                                            {campaign.linkedRewardId
                                                                ? rewardsCatalog.find(r => r.id === campaign.linkedRewardId)?.name || 'Linked reward'
                                                                : 'No linked reward'}
                                                        </p>
                                                    </td>
                                                    <td className="px-6 py-4 text-sm text-gray-700">{campaign.type}</td>
                                                    <td className="px-6 py-4 text-sm text-gray-700">
                                                        {campaign.startDate} – {campaign.endDate}
                                                    </td>
                                                    <td className="px-6 py-4">
                                                        <button
                                                            onClick={() => handleReinstateCampaign(campaign.id)}
                                                            className="px-3 py-1.5 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700"
                                                        >
                                                            Reinstate
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <Pagination
                                        page={archivedPage}
                                        totalItems={filteredArchivedCampaigns.length}
                                        pageSize={PAGE_SIZE}
                                        onPageChange={setArchivedPage}
                                    />
                                    </>
                                )
                            )}
                        </div>

                        <div className="border-t border-gray-200 px-6 py-4 flex justify-end flex-shrink-0">
                            <button
                                onClick={closeArchivedViewerModal}
                                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
